<template>
    <div class="container-fluid" id="dvcrud">
        <visualizadorestoque :idproduto="idprodutoestoque" :descricao="descproestoque"></visualizadorestoque>
        <fornecedoresproduto :idproduto="idprodutofornecedores" :descricao="descprofornecedores"></fornecedoresproduto>
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">PAINEL DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>                        
                        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Gerador de etiquetas" style="margin-right: 10px;" @click.prevent="mtdbaixaretiquetador()"><span aria-hidden="true"><i class="fa fa-tags"></i></span></button>                         -->
                        <export-excel style="display: none;" id="btexportarexcel"
                            :data   = "lstprodutosexportar"
                            :fields = "json_fields"
                            name    = "produtos.xls">
                        </export-excel>
                        <button type="button" class="close" title="Gerar catalogo de produtos" style="margin-right: 10px;" @click.prevent="mtdabremodalcatalogo()"><span aria-hidden="true"><i class="fa fa-th-large"></i></span></button>                         
                        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Exportar cadastros" style="margin-right: 10px;" @click.prevent="mtdexportarexcel()"><span aria-hidden="true"><i class="fa fa-upload"></i></span></button> -->
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Importar cadastro de produtos" style="margin-right: 10px;" @click.prevent="mtdrotinaimportacao()"><span aria-hidden="true"><i class="fa fa-download"></i></span></button>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                    <option value="2">Referência</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="edespecificacaopesq">Especificação:</label>
                                <input id="edespecificacaopesq" type="text" class="form-control form-control-sm" v-model="pespecificacao" @keyup="mtdlimpar_listagem()">
                            </div>                            
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Marca:</span>
                                <select id="cbmarcapesq" v-model="pidmarca"
                                        data-placeholder="Selecione uma marca"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Grupo:</span>
                                <select id="cbgrupopesq" v-model="pidgrupo"
                                        data-placeholder="Selecione um grupo"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12" v-bind:class="pmaisfiltros ? 'col-md-3 col-lg-3' : 'col-md-2 col-lg-2' ">
                                <span class="lblselect2">Subgrupo:</span>
                                <select id="cbsubgrupopesq" v-model="pidsubgrupo"
                                        data-placeholder="Selecione um subgrupo"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12" v-bind:class="pmaisfiltros ? 'col-md-3 col-lg-3' : 'col-md-2 col-lg-2' ">
                                <span class="lblselect2">Setor:</span>
                                <select id="cbsetorpesq" v-model="pidsetor"
                                        data-placeholder="Selecione um setor" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12" v-bind:class="pmaisfiltros ? 'col-md-3 col-lg-3' : 'col-md-2 col-lg-2' ">
                                <span class="lblselect2">NCM:</span>
                                <select id="cbncmpesq" data-placeholder="Selecione uma opção" v-model="pidncm"
                                     data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                              
                            <div class="col-sm-12 col-md-2 col-lg-1">
                                <label for="cbstpropesq">Sit.:</label>
                                <select name="cbstpropesq" class="form-control form-control-sm" id="cbstpropesq" v-model="pstpro" @change="mtdlimpar_listagem()" title="Situação dos produtos">
                                    <option value="0">Inativos</option>
                                    <option value="1">Ativos</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>                                                       
                            <div class="col-sm-12 col-md-2 col-lg-1">
                                <label for="cbfracionadopesq">Frac.:</label>
                                <select name="cbfracionadopesq" class="form-control form-control-sm" id="cbfracionadopesq" v-model="pfracionado" @change="mtdlimpar_listagem()" title="Condição para exibição dos produtos fracionados">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>                             
                            <div class="col-6 col-sm-6 col-md-2 col-lg-1">
                                <label for="cbqtdreg">Reg.:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()" title="Quantidade de registros a serem exibidos">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="500">500</option>
                                    <option value="1000">1000</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <template v-if="pmaisfiltros">
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="cbfracionadopesq">Filtrar por:</label>
                                    <select name="cbfiltrocadastropesq" class="form-control form-control-sm" id="cbfiltrocadastropesq" v-model="pfiltrocadastropesq" @change="mtdlimpar_listagem()">
                                        <option value="0">Data cadastro</option>
                                        <option value="1">Data alteração</option>
                                        <option value="2">Todos</option>
                                    </select>
                                </div>                            
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="eddtini">De:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="parseInt(pfiltrocadastropesq) === 2"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>								
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="eddtfim">Até:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="parseInt(pfiltrocadastropesq) === 2"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>																			
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="cbfiltroncmpesq">Com NCM:</label>
                                    <select name="cbfiltroncmpesq" class="form-control form-control-sm" id="cbfiltroncmpesq" v-model="pfiltroncmpesq" @change="mtdlimpar_listagem()">
                                        <option value="0">Não</option>
                                        <option value="1">Sim</option>
                                        <option value="2">Todos</option>
                                    </select>
                                </div>                                 							                                
                            </template>
                            <div class="col-1 col-sm-1 col-md-1 col-lg-1">
                                <button type="button" id="btmaisfiltros" class="btn btn-secondary btn-block btn-sm" @click.prevent="mtdmaisfiltros()" title="Mais opções de filtro"><i class="fa" v-bind:class="pmaisfiltros === false ? 'fa-angle-double-down' : 'fa-angle-double-up'"></i></button>
                            </div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Consultar</button>
                            </div>                                                       
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflstprodutos"
                                        :rows="lstprodutos"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="situacao_produto" slot-scope="item">
                                        <span v-if="parseInt(item.row.stpro) === 1" class="badge badge-pill badge-success">Ativo</span>
                                        <span v-else class="badge badge-pill badge-danger">Inativo</span>
                                    </template>
                                    <template slot="slot_qtd_estoque" slot-scope="item">
                                        <span v-if="parseFloat(item.row.quantidade) === 0" class="text-black-50 font-weight-bolder" style="font-size: 16px; cursor: pointer;" title="Produto sem saldo">{{ item.row.quantidade }}</span>
                                        <span v-else-if="parseFloat(item.row.quantidade) < 0" class="font-weight-bolder" style="color: #f82b54; font-size: 16px; cursor: pointer;" title="Produto com saldo negativo">{{ item.row.quantidade }}</span>
                                        <template v-else-if="parseFloat(item.row.estoqueminimo) > 0 && parseFloat(item.row.estoquemaximo) > 0">
                                            <span v-if="parseFloat(item.row.quantidade) > 0 && parseFloat(item.row.quantidade) < parseFloat(item.row.estoqueminimo)" class="font-weight-bolder" style="color: #ffbc00; font-size: 16px; cursor: pointer;" title="Produto atingiu seu estoque mínimo">{{ item.row.quantidade }}</span>                                        
                                            <span v-else-if="parseFloat(item.row.quantidade) > parseFloat(item.row.estoquemaximo)" class="font-weight-bolder" style="color: #4250f2; font-size: 16px; cursor: pointer;" title="Produto com saldo acima do estoque máximo">{{ item.row.quantidade }}</span>
                                            <span v-else class="font-weight-bolder" style="color: #0acf97; font-size: 16px; cursor: pointer;" title="Produto com saldo">{{ item.row.quantidade }}</span>                                            
                                        </template>
                                        <template v-else>
                                            <span class="font-weight-bolder" style="color: #0acf97; font-size: 16px; cursor: pointer;" title="Produto com saldo">{{ item.row.quantidade }}</span>                                            
                                        </template>                                        
                                    </template>
                                    <template slot="slot_precos" slot-scope="item">
                                        <ul class="list-group">
                                            <li v-for="(tabela, indexf) in item.row.tabelas" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px;">
                                                <span class="lblforma">{{tabela.desctabela}}</span>
                                                <span class="lblforma">{{formatavalores(parseFloat(tabela.prtabela), '')}}</span>
                                            </li>
                                        </ul>                                        
                                    </template>                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;">
											<i class="fa fa-navicon"></i>
										</button>                                        
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <div class="draco-prod-kpi">
                                    <span class="draco-prod-kpi-label">Itens exibidos carregados</span>
                                    <span class="draco-prod-kpi-value">{{lstprodutos.length}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-8 col-lg-8" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <div class="dropdown">
                                    <button type="button" class="btn btn-info btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
                                        <i class="fa fa-navicon"></i> Outras
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinaclasses()"><i class="fa fa-leanpub"></i> Atribuir/Remover classes</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinatabela()"><i class="fa fa-dollar"></i> Atribuir Tabela</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinacampos()"><i class="fa fa-list"></i> Atribuir campos</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinaarquivo()"><i class="fa fa-file"></i> Geração de arquivos</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinaoperacoestabelas()"><i class="fa fa-exchange"></i> Operações com tabelas</a>                                        
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinaconsultaprodutoscodigo()"><i class="fa fa-search"></i> Consultar por código</a>                                        
                                    </div>
                                </div>                                                
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Criar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvproduto">Produto</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvcustovenda">Custo/Venda</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvfiscal">Fiscal</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvcodigoslocalizacoes">Códigos/Localizações/Similaridades</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvobservacoes">Anotações/Detalhes</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvimagens">Imagens</a>
                                    </li>
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvproduto" class="container-fluid tab-pane active">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edid">ID interno:</label>
                                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                                       maxlength="20" style="text-transform: uppercase;" disabled/>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbstpro">Situação:</label>
                                                <select class="form-control form-control-sm" id="cbstpro" v-model="vstpro" v-bind:disabled="ativadesativa">
                                                    <option value="0">Inativo</option>
                                                    <option value="1">Ativo</option>
                                                </select>
                                            </div>
                                            <div v-if="parseInt(opcrud) > 1" class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddtcadastro">Data Cadastro:</label>
                                                <input type="text" v-model="vdtcadastro" disabled
                                                       class="form-control form-control-sm" id="eddtcadastro" maxlength="20">
                                            </div>
                                            <template v-if="parseInt(vidultimavenda) > 0">
                                                <div v-if="parseInt(opcrud) > 1 && vdtultimavenda !== null" class="col-sm-12 col-md-2 col-lg-2">
                                                    <label for="eddtultimavenda">Ult. venda:</label>
                                                    <input type="text" v-model="vdtultimavenda" disabled
                                                        class="form-control form-control-sm" id="eddtultimavenda">
                                                    <div class="dropdown dp-impressao-pedido">
                                                        <i class="fa fa-print icon-imprimir-pedido dropdown-toggle" title="Imprimir pedido" data-toggle="dropdown"></i>                                                                                                             
                                                        <div class="dropdown-menu">
                                                            <a class="dropdown-item" href="#" @click.prevent="mtdimprimirpedido(vidultimavenda, 0)">Padrão</a>
                                                            <a class="dropdown-item" href="#" @click.prevent="mtdimprimirpedido(vidultimavenda, 1)">Cupom</a>
                                                        </div>                                                        
                                                    </div>
                                                </div>    
                                            </template>                                        
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="eddescricao">*Nome de referência:</label>
                                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edreferencia">Referência:</label>
                                                <input type="text" v-model="vreferencia" v-bind:disabled="ativadesativa"
                                                       class="form-control form-control-sm" id="edreferencia" maxlength="20">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbfracionado">Fracionado:</label>
                                                <select class="form-control form-control-sm" id="cbfracionado" v-model="vfracionado"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0">Não</option>
                                                    <option value="1" selected="true">Sim</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Unidade:</span>
                                                <select id="cbunidade" v-model="vund" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione uma unidade" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddiasvalidade">Validade:</label>
                                                <input type="text" v-model="vdiasvalidade" v-bind:disabled="ativadesativa"
                                                       class="form-control form-control-sm" id="eddiasvalidade" min="0">
                                            </div>                                            
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbtipo">Tipo:</label>
                                                <select class="form-control form-control-sm" id="cbtipo" v-model="vtipo"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0" selected="true">Comercializado</option>
                                                    <option value="1">Consumo</option>
                                                    <option value="2">Ambos</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbserie">Controla seriais:</label>
                                                <select class="form-control form-control-sm" id="cbserie" v-model="vcontrolaserial"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0" selected="true">Não</option>
                                                    <option value="1">Sim</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Marca:</span>
                                                <select id="cbmarca" v-model="vidmarca" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione uma marca" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Grupo:</span>
                                                <select id="cbgrupo" v-model="vidgrupo" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione um grupo" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Subgrupo:</span>
                                                <select id="cbsubgrupo" v-model="vidsubgrupo" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione um subgrupo" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Setor:</span>
                                                <select id="cbsetorproduto" v-model="vidsetorproduto" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione um setor" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>                                            
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edestoqueminimo">Estoque mínimo:</label>
                                                <money type="text" class="form-control form-control-sm" id="edestoqueminimo" v-bind="quantidade"
                                                       v-model="vestoqueminimo" v-bind:disabled="ativadesativa" min="0"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edestoquemaximo">Estoque máximo:</label>
                                                <money type="text" class="form-control form-control-sm" id="edestoquemaximo" v-bind="quantidade"
                                                       v-model="vestoquemaximo" v-bind:disabled="ativadesativa" min="0"></money>
                                            </div>       
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edestoquemaximo">Fator comissão % :</label>
                                                <money type="text" class="form-control form-control-sm" id="edestoquemaximo" v-bind="quantidade"
                                                       v-model="vfatcomis" v-bind:disabled="ativadesativa" min="0"></money>
                                            </div>                                       
                                            <div class="col-sm-4 col-md-4 col-lg-4">
                                                <label for="edespecificacoes">Especificações:</label>
                                                <input type="text" v-model="vespecificacao" v-bind:disabled="ativadesativa"
                                                        class="form-control form-control-sm" id="edespecificacoes" maxlength="200">
                                            </div>                                            
                                        </div>
                                    </div>
                                    <div id="dvcustovenda" class="container-fluid tab-pane fade">
                                        <div class="card">
                                            <div class="card-header card-in">COMPOSIÇÃO DO CUSTO</div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edprcompra">Pr. Compra:</label>
                                                        <money type="text" class="form-control form-control-sm" id="edprcompra"
                                                               v-model="vprcompra" v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group"
                                                               style="text-align:right; background: honeydew; color:darkgreen; font-weight:bold;">
                                                        </money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edipi">IPI(%):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edipi" v-model="vpipi"
                                                               v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edicms">ICMS(%):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edicms" v-model="vpicms"
                                                               v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edfrete">Frete(%):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edfrete"
                                                               v-model="vpfrete" v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edpis">PIS(%):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edpis" v-model="vppis"
                                                               v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edcofins">COFINS(%):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edcofins"
                                                               v-model="vpcofins" v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edoutros">Outros(%):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edoutros"
                                                               v-model="vpoutros" v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edbcst">BC(ST):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edbcst" v-model="vbcst"
                                                               v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="cbcalculasubstrib">Subs. tributária:</label>
                                                        <select class="form-control form-control-sm" id="cbcalculasubstrib"
                                                                v-model="vcalculasubstributaria" v-bind:disabled="ativadesativa"
                                                                data-toggle=".ttgeral"
                                                                title="Selecione a opção 'Sim' quando for para calcular a substituição tributária.">
                                                            <option value="0" selected="true">Não</option>
                                                            <option value="1">Sim</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edaliquotast">Aliq.(ST):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edaliquotast"
                                                               v-model="vpst" v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edvlst">Vl.(ST):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edvlst" v-model="vvst"
                                                               v-bind="money" v-bind:disabled="ativadesativa"
                                                               v-bind:value="calculacusto" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edprcusto">Pr.Custo:</label>
                                                        <money type="text" class="form-control form-control-sm" id="edprcusto"
                                                               v-model="vprcusto" v-bind="money" v-bind:disabled="ativadesativa"
                                                               data-bv-group=".group" style="text-align:right; background: honeydew; color:darkgreen; font-weight:bold;">
                                                        </money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-8 col-lg-8">
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 25px;">
                                                        <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                                            <input type="checkbox" class="custom-control-input" id="swcalcularprvendamedio" 
                                                            name="swcalcularprvendamedio" v-model="vcalcularprvendamedio" v-bind:disabled="ativadesativa"
                                                            @change="mtdcalculaprvendamedio()">
                                                            <label class="custom-control-label" for="swcalcularprvendamedio">Informar Pr. Venda</label>
                                                        </div>						                                
                                                    </div>                                                    
                                                    <div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edprvendamedio1">Pr. venda({{ vmargemprcusto }}%):</label>
                                                        <div class="input-group" style="z-index: 1;">
                                                            <money type="text" class="form-control form-control-sm" id="edprvendamedio1" title="Este preço é utilizado apenas para o cálculo do custo. O preços preços de venda a serem utilizados deverão ser informados na listagem abaixo!"
                                                                v-model="vprvendamedio" v-bind="money" v-bind:disabled="!vcalcularprvendamedio && !ativadesativa"
                                                                data-bv-group=".group" style="text-align:right; background: #b6c5b6; color:darkgreen; font-weight:bold;"
                                                                @blur.native="mtdcalculaprvendamedio()">
                                                            </money>
                                                            <div class="input-group-append" style="height: 31px;">
                                                                <button class="btn btn-primary" v-bind:disabled="!vcalcularprvendamedio" title="Informar a margem(%)" @click.prevent="mtddefinirmargemprvenda()" style="border-top-left-radius: 0px!important; border-bottom-left-radius: 0px!important;"><i class="fa fa-percent"></i></button>
                                                            </div>                                                            
                                                        </div>
                                                    </div>
                                                    <div v-else class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edprvendamedio2">Pr.Venda:</label>
                                                        <money type="text" class="form-control form-control-sm" id="edprvendamedio2"
                                                               v-model="vprvendamedio" v-bind="money" v-bind:disabled="true"
                                                               data-bv-group=".group" style="text-align:right; background: #b6c5b6; color:darkgreen; font-weight:bold;">
                                                        </money>
                                                    </div>                                                                                       
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card" style="margin-top: 15px;">
                                            <div class="card-header card-in">*COMPOSIÇÃO DE PREÇOS DE VENDA</div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <template v-if="parseInt(voptabela) === 2">
                                                        <div class="col-sm-12 col-md-6 col-lg-6">
                                                            <span class="lblselect2">Tabela:</span>
                                                            <select id="cbtabelapreco" v-model="vidtabelapreco" v-bind:disabled="habdestab"
                                                                    data-placeholder="Selecione uma tabela" data-allow-clear="true" style="width:100%;">
                                                            </select>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="col-sm-12 col-md-8 col-lg-8">
                                                            <span class="lblselect2">Tabela:</span>
                                                            <select id="cbtabelapreco" v-model="vidtabelapreco" v-bind:disabled="habdestab"
                                                                    data-placeholder="Selecione uma tabela" data-allow-clear="true" style="width:100%;">
                                                            </select>
                                                        </div>
                                                    </template>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edmrgtabela">Mrg(%):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edmrgtabela"
                                                               v-model="vmrgtabela" v-bind="money" v-bind:disabled="ativadesativa" 
                                                               data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edvltabela">Valor:</label>
                                                        <div class="input-group" style="z-index: 1;">
                                                            <money type="text" class="form-control form-control-sm" id="edvltabela"
                                                                v-model="vvltabela" v-bind="money" v-bind:disabled="ativadesativa"
                                                                data-bv-group=".group" style="text-align:right; background: honeydew; color:darkgreen; font-weight:bold;">
                                                            </money>
                                                            <div class="input-group-append" style="height: 31px;">
                                                                <button class="btn btn-primary" title="Visualizar imposto sobre valor" @click.prevent="mtdvisualizarimpostovalor()" style="border-top-left-radius: 0px!important; border-bottom-left-radius: 0px!important;"><i class="fa fa-dollar"></i></button>
                                                            </div>                                                            
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edcomissaotabela">Comissão(%):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edcomissaotabela"
                                                               v-model="vcomissaotabela" v-bind="money" v-bind:disabled="ativadesativa"
                                                               data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="eddescontotabela">Qtd. Mínima:</label>
                                                        <money type="text" class="form-control form-control-sm" id="eddescontotabela"
                                                               v-model="vqtdmintabela" v-bind="money" v-bind:disabled="ativadesativa"
                                                               data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edqtdmintabela">Desc. Qtd. Min. ($):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edqtdmintabela"
                                                               v-model="vdescontotabela" v-bind="money" v-bind:disabled="ativadesativa"
                                                               data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>                                                    
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edvldescpromocional">Desc. promocional(%):</label>
                                                        <div class="input-group" style="z-index: 1;">
                                                            <money type="text" class="form-control form-control-sm" id="edvldescpromocional"
                                                                v-model="vvldescpromocional" v-bind="money" v-bind:disabled="ativadesativa"
                                                                data-bv-group=".group" style="text-align:right; background: honeydew; color:darkgreen; font-weight:bold;">
                                                            </money>
                                                            <div class="input-group-append" style="height: 31px;">
                                                                <button class="btn btn-primary" title="Informar o valor para calcular o percentual" @click.prevent="mtdinformarvalordescpromocional()" style="border-top-left-radius: 0px!important; border-bottom-left-radius: 0px!important;"><i class="fa fa-dollar"></i></button>
                                                            </div>                                                             
                                                        </div>
                                                    </div> 
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edqtdmintabela">Pr. auxiliar($):</label>
                                                        <money type="text" class="form-control form-control-sm" id="edqtdmintabela" title="Este preço é utilizado apenas para definir o valor de tabela para visualização na impressão/catalogo de produtos"
                                                               v-model="vvlvizu" v-bind="money" v-bind:disabled="ativadesativa"
                                                               data-bv-group=".group" style="text-align:right;">
                                                        </money>
                                                    </div>                                                                                                 
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <button v-if="parseInt(voptabela) === 1" type="button" id="btinctabela" class="btn btn-info btn-sm"
                                                                @click.prevent="mtdgravartabela()" v-bind:disabled="ativadesativa"
                                                                style="width:100%; margin-top: 21px;"><i class="fa fa-plus-circle"></i>
                                                            Incluir
                                                        </button>
                                                        <button v-else type="button" id="btalttabela" class="btn btn-secondary btn-sm"
                                                                @click.prevent="mtdgravartabela()" v-bind:disabled="ativadesativa"
                                                                style="width:100%; margin-top: 21px;"><i class="fa fa-check"></i>
                                                            Salvar
                                                        </button>                                                        
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <button v-if="parseInt(voptabela) === 2" type="button" id="btcancelartabela" class="btn btn-secondary btn-sm"
                                                                @click.prevent="mtdcancelartabela()"
                                                                style="width:100%; margin-top: 21px;"><i class="fa fa-undo"></i>
                                                            Fechar
                                                        </button>                                                        
                                                    </div>                                                    
                                                    <div v-if="lstTabelasPrecos.length > 0" class="col-lg-12">
                                                        <div class="table-responsive">
                                                            <table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                <thead class="thead-light">
                                                                <tr>
                                                                    <th width="280">Tabela:</th>
                                                                    <th width="100">Valor:</th>
                                                                    <th width="100">Mrg(%):</th>
                                                                    <th width="100">Com.(%):</th>
                                                                    <th width="100">Qtd. Min.:</th>
                                                                    <th width="100">Pr. aux. ($):</th>
                                                                    <th width="100">Desc. Qtd. ($):</th>
                                                                    <th width="100">Desc. Promocional:</th>
                                                                    <th width="35px" style="text-align: center;">Exc:</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody id="lsttabelaspro">
                                                                    <tr v-for="(tabela, index) in lstTabelasPrecos" v-bind:key="index">
                                                                        <td width="150px">{{ tabela.desctabela }}</td>
                                                                        <td width="100px" style="text-align: right; font-weight: bold;">{{
                                                                            formatavalores(tabela.prtabela) }}
                                                                        </td>
                                                                        <td width="100px" style="text-align: right;">{{
                                                                            formatavalores(tabela.mrglucro) }}
                                                                        </td>
                                                                        <td width="100px" style="text-align: right;">{{
                                                                            formatavalores(tabela.pcomissao) }}
                                                                        </td>
                                                                        <td width="100px" style="text-align: right;">{{
                                                                            formatavalores(tabela.qtdminima) }}
                                                                        </td>
                                                                        <td width="100px" style="text-align: right;">{{
                                                                            formatavalores(tabela.vlvisualiza) }}
                                                                        </td>
                                                                        <td width="100px" style="text-align: right;">{{
                                                                            formatavalores(tabela.desconto) }}
                                                                        </td>
                                                                        <td v-if="parseFloat(tabela.vldescpromocional) > 0" width="120px" style="text-align: right; color: #0acf97; font-weight: bold;">
                                                                            {{ formatavalores(tabela.vldescpromocional) }}% (${{ formatavalores(parseFloat(tabela.prtabela) - (tabela.prtabela * parseFloat(tabela.vldescpromocional) / 100)) }})
                                                                        </td>                                                                        
                                                                        <td v-else width="120px">
                                                                        </td>
                                                                        <td width="80px" class="center" style="text-align: center;">
                                                                            <a class="btn btn-secondary btn-sm btn-opcrud ajt-btn" href="#"
                                                                            v-bind:disabled="ativadesativa"
                                                                            @click.prevent="mtdalterartabela(tabela)"><i class="fa fa-edit"></i></a>
                                                                            <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                            v-bind:disabled="ativadesativa"
                                                                            @click.prevent="mtddeletatabela(index)"><i class="fa fa-trash"></i></a>                                                                            
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                        
                                    </div>
                                    <div id="dvfiscal" class="container-fluid tab-pane fade">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <span class="lblselect2">*NCM({{vidncm}}):</span>
                                                <select id="cbncm" data-placeholder="Selecione uma opção" v-model="vidncm"
                                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <span class="lblselect2">CEST({{vidcest}}):</span>
                                                <select id="cbcest" data-placeholder="Selecione uma opção" v-model="vidcest"
                                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div> 
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <span class="lblselect2">St(Entrada):</span>
                                                <select id="cbsituacaotributaria" data-placeholder="Selecione uma opção" v-model="vidsituacaotributaria"
                                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>                                             
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="cbtipoproduto">Tipo de produto:</label>
                                                <select class="form-control form-control-sm" id="cbtipoproduto" v-model="vtipoproduto"
                                                    v-bind:disabled="ativadesativa">
                                                    <option value="0">00 - MERCADORIA PARA REVENDA</option>
                                                    <option value="1">01 - MATERIA-PRIMA</option>
                                                    <option value="2">02 - EMBALAGEM</option>
                                                    <option value="3">03 - PRODUTO EM PROCESSO</option>
                                                    <option value="4">04 - PRODUTO ACABADO</option>
                                                    <option value="5">05 - SUBPRODUTO</option>
                                                    <option value="6">06 - PRODUTO INTERMEDIARIO</option>
                                                    <option value="7">07 - MATERIAL DE USO E CONSUMO</option>
                                                    <option value="8">08 - ATIVO IMOBILIZADO</option>
                                                    <option value="9">09 - SERVICOS</option>
                                                    <option value="10">10 - OUTROS INSUMOS</option>
                                                    <option value="99">99 - OUTRAS</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="cborigemproduto">Origem:</label>
                                                <select class="form-control form-control-sm" id="cborigemproduto"
                                                    v-model="vorigemproduto" v-bind:disabled="ativadesativa">
                                                    <option value="0">0 - NACIONAL, EXCETO AS INDICADAS NOS CODIGOS 3 A 5</option>
                                                    <option value="1">1 - ESTRANGEIRA - IMPORTACAO DIRETA, EXCETO A INDICADA NO
                                                        CODIGO 6
                                                    </option>
                                                    <option value="2">2 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, EXCETO A
                                                        INDICADA NO CODIGO 7
                                                    </option>
                                                    <option value="3">3 - NACIONAL, MERCADORIA OU BEM COM CONTEUDO DE IMPORTACAO
                                                        SUPERIOR A 40% (QUARENTA POR CENTO)
                                                    </option>
                                                    <option value="4">4 - NACIONAL, CUJA PRODUCAO TENHA SIDO FEITA EM CONFORMIDADE
                                                        COM OS PROCESSOS PRODUTIVOS BASICOS DE QUE TRATAM O DECRETO-LEI Nº 288/67 E
                                                        AS LEIS N°S 8.248/91, 8.387/91,10.176/01 e 11.484/07
                                                    </option>
                                                    <option value="5">5 - NACIONAL, MERCADORIA OU BEM COM CONTEUDO DE IMPORTACAO
                                                        INFERIOR OU IGUAL A 40% (QUARENTA POR CENTO)
                                                    </option>
                                                    <option value="6">6 - ESTRANGEIRA - IMPORTACAO DIRETA, SEM SIMILAR NACIONAL,
                                                        CONSTANTE EM LISTA DE RESOLUCAO CAMEX
                                                    </option>
                                                    <option value="7">7 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, SEM SIMILAR
                                                        NACIONAL, CONSTANTE EM LISTA DE RESOLUCAO CAMEX"
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="cbprodutoespecifico">Produto específico:</label>
                                                <select class="form-control form-control-sm" id="cbprodutoespecifico"
                                                    v-model="vprodutoespecifico" v-bind:disabled="ativadesativa">
                                                    <option value="0"></option>
                                                    <option value="1">Veículo</option>
                                                    <option value="2">Medicamento</option>
                                                    <option value="3">Armamento</option>
                                                    <option value="4">Combustível</option>
                                                    <option value="5">Papel Imune</option>
                                                </select>
                                            </div>
                                            <div class="col-md-12" style="margin-top: 15px;">
                                                <div class="card">
                                                    <div class="card-header card-in">CLASSES DE IMPOSTOS</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-sm-12 col-md-5 col-lg-5" id="dvclasse">
                                                                <span class="lblselect2">Classe:</span>
                                                                <select id="cbclasse" data-placeholder="Selecione uma opção"
                                                                    v-model="vidclasse" v-bind:disabled="ativadesativa"
                                                                    data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>                                                            
                                                            <div class="col-sm-12 col-md-5 col-lg-5" id="dvfilialclasse">
                                                                <span class="lblselect2">Filial:</span>
                                                                <select id="cbfilialclasse" data-placeholder="Selecione uma opção"
                                                                    v-model="vidfilialclasse" v-bind:disabled="ativadesativa"
                                                                    data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>
                                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                                <button type="button" id="btincclasse" class="btn btn-info btn-sm"
                                                                    v-bind:disabled="ativadesativa"
                                                                    style="width:100%; margin-top: 22px;" @click.prevent="mtdincluirclasse()"><i class="fa fa-plus-circle"></i>
                                                                    Incluir
                                                                </button>
                                                            </div>
                                                            <div class="col-lg-12">
                                                                <div class="table-responsive">
                                                                    <table id="tblistaclasses" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                        <thead class="thead-light">
                                                                            <tr>
                                                                                <th width="300">Classe:</th>
                                                                                <th width="300">Filial:</th>
                                                                                <th width="35px" style="text-align: center;">Exc:</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody id="lstclassespro">
                                                                            <tr v-for="(classe, index) in lstClassesProduto" v-bind:key="index">
                                                                                <td width="300px">{{ classe.descclasse }}</td>
                                                                                <td width="300px">{{ classe.fantasia }}</td>
                                                                                <td width="35px" class="center" style="text-align: center;">
                                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                                    v-bind:disabled="ativadesativa"
                                                                                    @click.prevent="mtdexcluirclasse(index)"><i class="fa fa-trash"></i></a>
                                                                                </td>                                                                                    
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>                                                                                                                        
                                                        </div>
                                                    </div>
                                                </div>                                                 
                                            </div>                                                                                                                                                                                                                                                                      
                                        </div>
                                    </div>
                                    <div id="dvcodigoslocalizacoes" class="container-fluid tab-pane fade">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="card">
                                                    <div class="card-header card-in">CÓDIGOS</div>
                                                    <div class="card-body" style="height: 226px;">
                                                        <div class="row">
                                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                                <label for="edcodigoadd">ID interno:</label>
                                                                <input type="text" class="form-control form-control-sm" id="edcodigoadd"
                                                                    v-model="vcodigoinc" v-bind:disabled="ativadesativa"
                                                                    data-bv-group=".group" style="text-transform: uppercase;">
                                                            </div>
                                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                                <button type="button" id="btinccodigo" class="btn btn-info btn-sm"
                                                                        v-bind:disabled="ativadesativa" @click.prevent="mtdinccodigo()"
                                                                        style="width:100%; margin-top: 22px; margin-bottom: 10px;">
                                                                    <i class="fa fa-plus-circle"></i> Incluir</button>
                                                            </div>
                                                            <div v-if="lstCodigos.length > 0" class="col-lg-12" style="height: 123px; overflow-y: auto;">
                                                                <div class="table-responsive">
                                                                    <table id="tblistacodigospro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                        <thead class="thead-light">
                                                                        <tr>
                                                                            <th>ID interno:</th>
                                                                            <th width="35px" style="text-align: center;">E.P:</th>
                                                                            <th width="35px" style="text-align: center;">Exc:</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody id="lstcodigospro">
                                                                            <tr v-for="(codigo, index) in lstCodigos" v-bind:key="index">
                                                                                <td>{{ codigo.codigo }}</td>
                                                                                <td v-if="parseInt(codigo.padraoetiqueta) === 0" style="cursor: pointer; text-align: center;" @click.prevent="mtddefinecodigoetqpadrao(codigo.codigo, 1, index)"></td>
                                                                                <td v-else style="cursor: pointer; text-align: center; font-size: 20px; color: #17a2b8;" title="Código padrão para emissão das etiquetas" @click.prevent="mtddefinecodigoetqpadrao(codigo.codigo, 0, index)"><i class="fa fa-tags"></i></td>
                                                                                <td width="35px" class="center" style="text-align: center;">
                                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                                    v-bind:disabled="ativadesativa"
                                                                                    @click.prevent="mtddelcodigo(index)"><i class="fa fa-trash"></i></a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="card">
                                                    <div class="card-header card-in">SIMILARIDADES POR REFERÊNCIA</div>
                                                    <div class="card-body" style="height: 226px;">
                                                        <div class="row">
                                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                                <label for="edreferenciasimilar">Referência:</label>
                                                                <input type="text" class="form-control form-control-sm" id="edreferenciasimilar"
                                                                    v-model="vreferenciasimilarinc" v-bind:disabled="ativadesativa"
                                                                    data-bv-group=".group" style="text-transform: uppercase;">
                                                            </div>
                                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                                <button type="button" id="btincreferencia" class="btn btn-info btn-sm"
                                                                        v-bind:disabled="ativadesativa" @click.prevent="mtdincreferenciasimilar()"
                                                                        style="width:100%; margin-top: 22px; margin-bottom: 10px;">
                                                                    <i class="fa fa-plus-circle"></i> Incluir</button>
                                                            </div>
                                                            <div v-if="lstsimilaridades.length > 0" class="col-lg-12" style="height: 123px; overflow-y: auto;">
                                                                <div class="table-responsive">
                                                                    <table id="tblistasimilaridades" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                        <thead class="thead-light">
                                                                        <tr>
                                                                            <th>Referência:</th>
                                                                            <th width="35px" style="text-align: center;">Exc:</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody id="lstsimilaridades">
                                                                            <tr v-for="(referencia, index) in lstsimilaridades" v-bind:key="index">
                                                                                <td>{{ referencia.referencia }}</td>
                                                                                <td width="35px" class="center" style="text-align: center;">
                                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                                    v-bind:disabled="ativadesativa"
                                                                                    @click.prevent="mtddelreferenciasimilar(index)"><i class="fa fa-trash"></i></a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="card" style="margin-top: 15px;">
                                                    <div class="card-header card-in">LOCALIZAÇÕES</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-sm-12 col-md-4 col-lg-4" id="dvfiliallocalizacao">
                                                                <span class="lblselect2">Filial:</span>
                                                                <select id="cbfiliallocalizacao" v-model="vidfiliallocalizacao"
                                                                        v-bind:disabled="ativadesativa" data-placeholder="Selecione uma filial"
                                                                        data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>                                                            
                                                            <div v-show="vnovalocalizacao" class="col-sm-12 col-md-3 col-lg-3">
                                                                <label for="eddescricaolocalizacao">Localização:</label>
                                                                <div class="input-group" style="z-index: 1;">
                                                                <input type="text" class="form-control form-control-sm" id="eddescricaolocalizacao"
                                                                    v-model="vdescricaolocalizacao" v-bind:disabled="ativadesativa"
                                                                    data-bv-group=".group" style="text-transform: uppercase;" maxlength="50">
                                                                    <div class="input-group-append">
                                                                        <a href="#" class="btn btn-primary btn-sm btn-grp" role="button" @click.prevent="mtdconfirmarnovalocalizacao()" style="border-radius: 0px 0px 0px 0px!important;" title="Confirmar"><i class="fa fa-check" style="padding-top: 3px;"></i></a>
                                                                        <a href="#" class="btn btn-secondary btn-sm btn-grp" role="button" @click.prevent="mtdcancelarnovalocalizacao()" style="border-radius: 0px 4px 4px 0px!important;" title="Fechar"><i class="fa fa-close" style="padding-top: 3px;"></i></a>
                                                                    </div>                                                                    
                                                                </div>
                                                            </div>
                                                            <div v-show="!vnovalocalizacao" class="col-sm-12 col-md-3 col-lg-3" id="dvlocalizacao">
                                                                <span class="lblselect2">Localização:</span>
                                                                <select id="cblocalizacao" v-model="vidlocalizacao"
                                                                        v-bind:disabled="ativadesativa" data-placeholder="Selecione uma localização"
                                                                        data-allow-clear="true" style="width:100%;">
                                                                </select>
                                                            </div>
                                                            <div v-show="!vnovalocalizacao" class="col-sm-12 col-md-2 col-lg-2">
                                                                <button type="button" id="btinclocalizacao" v-bind:disabled="ativadesativa"
                                                                        class="btn btn-info btn-sm" @click="mtdinclocalizacao()"
                                                                        style="width:100%; margin-top: 22px; margin-bottom: 10px;"><i
                                                                        class="fa fa-plus-circle"></i> Incluir
                                                                </button>
                                                            </div>
                                                            <div v-show="!vnovalocalizacao" class="col-sm-12 col-md-2 col-lg-2">
                                                                <button type="button" id="btnovalocalizacao" v-bind:disabled="ativadesativa"
                                                                        class="btn btn-secondary btn-sm" @click="mtdnovalocalizacao()"
                                                                        style="width:100%; margin-top: 22px; margin-bottom: 10px;"><i
                                                                        class="fa fa-file"></i> Nova Localização
                                                                </button>
                                                            </div>                                                                                                                        
                                                            <div v-if="lstLocalizacaoProduto.length > 0" class="col-lg-12">
                                                                <div class="table-responsive">
                                                                    <table id="tblistaestoque" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                        <thead class="thead-light">
                                                                        <tr>
                                                                            <th width="300">Filial:</th>
                                                                            <th width="100">Localização:</th>
                                                                            <th width="35px" style="text-align: center;">Exc:</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody id="lstlocalizacaopro">
                                                                            <tr v-for="(localizacao, index) in lstLocalizacaoProduto" v-bind:key="index">
                                                                                <td width="300px">{{ localizacao.fantasia }}</td>
                                                                                <td width="100px">{{ localizacao.desclocalizacao }}</td>
                                                                                <td width="35px" class="center" style="text-align: center;">
                                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                                    v-bind:disabled="ativadesativa"
                                                                                    @click.prevent="mtddeletarlocalizacao(index)"><i class="fa fa-trash"></i>
                                                                                    </a>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>    
                                    </div>
                                    <div id="dvobservacoes" class="container-fluid tab-pane fade">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <textarea class="form-control center" rows="8" id="txtobs" v-model="vobservacoes" v-bind:disabled="ativadesativa"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="dvimagens" class="container-fluid tab-pane fade">
                                        <div class="row" style="padding: 0px 15px 0px 15px;">
                                            <div class="col-md-12 border rounded" style="padding-top: 15px;">
                                                <div v-if="lstImagens.length > 0" class="row">
                                                    <div v-for="(imagem, index) in lstImagens" v-bind:key="index" class="col-md-2 text-center" style="margin-bottom: 15px;">                                            
                                                        <button v-if="parseInt(opcrud) < 3" type="button" class="btn btn-danger btn-sm btn-del-imgproduto" @click.prevent="mtdexcluirimgproduto(imagem.patharquivo)"><i class="fa fa-trash"></i></button>
                                                        <img class="img-thumbnail img-produto" v-bind:src="pathimgview+imagem.patharquivo">                                                  
                                                    </div>
                                                </div>
                                                <div v-else class="row">
                                                    <div class="col-md-12 text-center">
                                                        <h6 style="font-size: 12px; padding-bottom: 5px;">Sem imagens para visualização</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="parseInt(opcrud) < 3" class="col-md-12 text-center" style="margin-top: 15px;">
                                                <input
                                                    type="file" 
                                                    id="ipselecionarimg"
                                                    accept="image/png, image/jpeg" 
                                                    @change="mtdselecionarimagem" 
                                                    style="display: none;"
                                                    ref="if_imgproduto">
                                                <button type="button" @click="$refs.if_imgproduto.click()" class="btn btn-primary btn-sm"><i class="fa fa-picture-o"></i> Adicionar imagem</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                                
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos obrigatórios são sinalizados com \*</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Salvar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Editar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Remover
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pnimportacao" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">CENTRAL DE IMPORTAÇÃO DE PRODUTOS</span>                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" style="padding: 30px;">
                        <div class="row">
                                <div class="col-md-12" style="padding-bottom: 15px!important;">
                                    <h1 style="color: #0acf97!important;" class="text-info">CENTRAL DE IMPORTAÇÃO</h1>
                                </div>
                                <div class="col-md-12">
                                    <p style="text-indent: 1.5em; font-size: 14px; color: #666;">
                                        Para este procedimento uma matriz de arquivo no formato do EXCEL(.xls) está disponibilizada para download. Basta clicar no link a baixo para baixá-la.
                                        Preencha a mesma com os dados corretamente, sem alterar as posições das colunas.
                                        Após o preenchimento, salve os dados e clique em "Enviar arquivo". Aguarde o processamento, ao final o sistema irá listar o resultado da importação.</p>
                                    <p style="font-size: 14px; color: #666; margin-left: 50px;">
                                        Campos de CNPJ, telefone, CEP, devem ser informados somente os números, sem formatação;<br>
                                        Campo de Data deve ser informados no formato dd/mm/aaaa, sendo que os mesmos devem estar formatados como texto no EXCEL (utilize a fórmula <strong>=TEXTO(A1; "dd/mm/aaaa")</strong>, em seguida copiar e colar especial).<br>
                                    </p>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="custom-control custom-checkbox chbajuste">
                                        <input type="checkbox" class="custom-control-input" id="cblimpardados" v-model="vlimpardados">
                                        <label class="custom-control-label" for="cblimpardados" style="color: #f82b54;">Limpar cadastro existente</label>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="custom-control custom-checkbox chbajuste">
                                        <input type="checkbox" class="custom-control-input" id="cbimportarcodigos" v-model="vimportarcodigos">
                                        <label class="custom-control-label" for="cbimportarcodigos" style="color: #f82b54;">Manter códigos</label>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div v-if="vlimpardados" class="custom-control custom-checkbox chbajuste">
                                        <input type="checkbox" class="custom-control-input" id="cbreconstruirchaves" v-model="vreconstruirchaves" title="Em caso de erro durante o processo de importação, marcar esta opção pra reconstruir as chaves estrageiras da tabela de produtos.">
                                        <label class="custom-control-label" for="cbreconstruirchaves" style="color: #f82b54;">Reconstruir chaves</label>
                                    </div>
                                </div>                                                                
                                <div class="col-md-6">
                                    <input type="file" id="btselecionararqenviar" accept=".xls" style="display: none;">
                                </div>
                                <div class="col-md-2">
                                    <button type="button" class="btn btn-green" @click.prevent="mtdbaixarmatriz()" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;">
                                        <img src="@/assets/matrizexcel.png">
                                        Baixar matriz
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <input
                                        type="file" 
                                        id="ipselecionararquivo"
                                        accept=".xls" 
                                        @change="mtdselecionararquivo" 
                                        style="display: none;"
                                        ref="if_selecionarquivo">                                    
                                    <button type="button" @click="$refs.if_selecionarquivo.click()" class="btn btn-blue" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;"><i class="fa fa-upload"></i>
                                        Enviar arquivo
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <input type="file" id="btselecionararquivo" accept=".xls" style="display: none;">
                                    <div class="dropdown">
                                        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;">
                                            <i class="fa fa-list-ol"></i> Códigos
                                        </button>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item" href="#" @click.prevent="mtdbaixarmatrizcodigos()">Baixar matriz</a>
                                            <a class="dropdown-item" href="#" @click.prevent="mtdarquivocodigos()">Enviar arquivo</a>
                                        </div>
                                    </div>                                    
                                </div>                                
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10">
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdcancelaredicao()"><i class="fa fa-close"></i> Fechar</button>
                            </div>
                        </div>
                    </div>                                        
                </div>                
            </div>
        </div>

        <!-- Ajustar estoque -->
        <div class="modal fade" id="mdajuste" tabindex="-1">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-cubes" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">AJUSTE DE ESTOQUE</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edidproduto">ID interno:</label>
                                <input type="text" v-model="vidproduto" disabled="disabled"
                                    class="form-control form-control-sm" id="edidproduto">                                            
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="eddescpro">Descrição do produto:</label>
                                <input type="text" v-model="vdescpro" disabled="disabled"
                                        class="form-control form-control-sm" id="eddescpro" maxlength="50"
                                        style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edqtdanterior">Estoque anterior:</label>
                                <money class="form-control form-control-sm" id="edqtdanterior" 
                                    v-bind="quantidade" v-model="vqtdanterior"
                                    value="0,00" data-bv-group=".group" disabled="disabled" 
                                    style="text-align:right; font-weight: bold; background-color: honeydew; color: darkgreen;"></money>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edund">Unidade:</label>
                                <input type="text" v-model="vundanterior" disabled="disabled"
                                    class="form-control form-control-sm" id="edund" maxlength="2"
                                    style="text-transform: uppercase;">
                            </div>                              
                        </div>

                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="cbestoque">Estoque:</label>
                                <select id="cbestoque" v-model="videstoque"
                                        data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edqtdmov">Quantidade:</label>
                                <money class="form-control form-control-sm" id="edqtdmov" 
                                    v-bind="quantidade" v-model="vqtdmov"
                                    value="0,00" data-bv-group=".group" 
                                    style="text-align:right; font-weight: bold; background-color: honeydew; color: darkgreen;"></money>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edund">Unidade:</label>
                                <input type="text" v-model="vunidadepro" disabled="disabled"
                                    class="form-control form-control-sm" id="edund" maxlength="2"
                                    style="text-transform: uppercase;">
                            </div>                  
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edvlmov">Vl. Custo:</label>
                                <money class="form-control form-control-sm" id="edvlmov" disabled="disabled" 
                                    v-bind="money" v-model="vvlmov"
                                    value="0,00" data-bv-group=".group" 
                                    style="text-align:right;"></money>
                            </div>    
                        </div>

                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddocmov">Documento:</label>
                                <input type="text" v-model="vdocmov" 
                                    class="form-control form-control-sm" id="eddocmov" maxlength="20"
                                    style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddtmov">Data Movimento:</label>
                                <date-picker id="eddtmov" v-model="vdtmov" :config="options" 
                                        class="form-control form-control-sm"></date-picker>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbtpmov">Tipo de movimento:</label>
                                <select class="form-control form-control-sm" id="cbtpmov" v-model="vtpmov">
                                    <option value="0">Entrada</option>
                                    <option value="1">Saída</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbperda">Lançar como perda:</label>
                                <select class="form-control form-control-sm" id="cbperda" v-model="vperda">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>                          
                        </div>

                        <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="cbfilialajuste">Filial:</label>
                                <select id="cbfilialajuste" v-model="vidfilialajuste"
                                        data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>                            
                        </div>
         				
                        <div class="row" style="margin-top: 10px;">
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="edobsmov">Motivo/Justificativa:</label>
                                <div class="form-group">
                                    <textarea class="form-control"
                                        rows="3" id="edobsmov" v-model="vobsmov" style="text-transform: uppercase;"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdconfirmarajuste()" class="btn btn-primary btn-sm">Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Fechar</button>
                    </div>                          
                </div>
            </div>
        </div>
        <!-- Atribuir classe --> 
        <div class="modal fade" id="mdatribuirclasse" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir/Remover Classe de imposto a produtos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbopcaoclasse">Opção:</label>
                                <select name="cbopcaoclasse" class="form-control form-control-sm" id="cbopcaoclasse" v-model="vopcaoclasseatribuir">
                                    <option value="0">Atribuir</option>
                                    <option value="1">Remover</option>
                                </select>
                            </div>                            
                            <div class="col-md-12" id="dvfilialatribuir">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialatribuir" data-placeholder="Selecione uma opção"
                                    v-model="vidfilialatribuir"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                                                        
                            <div class="col-md-12" id="dvclasseatribuir">
                                <span class="lblselect2">Classe:</span>
                                <select id="cbclasseatribuir" data-placeholder="Selecione uma opção"
                                    v-model="vidclasseatribuir"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-md-12" style="padding-top: 10px; padding-bottom: 15px;">
                                <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                    <input type="checkbox" class="custom-control-input" id="swctodosprodutos" name="swctodosprodutos" v-model="vatribuitodosprodutos">
                                    <label class="custom-control-label" for="swctodosprodutos">Aplicar a todos os produtos</label>
                                </div>                                
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdatribuirclasse()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div>
        <!-- Atribuir campos --> 
        <div class="modal fade" id="mdatribuircampos" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir campos aos produtos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body" style="padding-top: 5px;">                        
                        <div class="row">
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirsituacao" v-model="vatribuirsituacao">
                                    <label class="custom-control-label" for="cbatribuirsituacao"></label>
                                </div>
                            </div>                            
                            <div class="col-sm-11 col-md-5 col-lg-5">
                                <label for="cbsituacaocampos">Situação:</label>
                                <select class="form-control form-control-sm" id="cbsituacaocampos" v-model="vsituacaocampos" v-bind:disabled="!vatribuirsituacao">
                                    <option value="0">Inativo</option>
                                    <option value="1">Ativo</option>
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirreferencia" v-model="vatribuirreferencia">
                                    <label class="custom-control-label" for="cbatribuirreferencia"></label>
                                </div>
                            </div>
                            <div class="col-sm-11 col-md-5 col-lg-5">
                                <label for="edreferenciacampos">Referência:</label>
                                <input type="text" v-model="vreferenciacampos"
                                        class="form-control form-control-sm" id="edreferenciacampos" maxlength="20" v-bind:disabled="!vatribuirreferencia">
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirfracionado" v-model="vatribuirfracionado">
                                    <label class="custom-control-label" for="cbatribuirfracionado"></label>
                                </div>
                            </div>                            
                            <div class="col-sm-11 col-md-5 col-lg-5">
                                <label for="cbfracionadocampos">Fracionado:</label>
                                <select class="form-control form-control-sm" id="cbfracionadocampos" v-model="vfracionadocampos" v-bind:disabled="!vatribuirfracionado">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridunidade" v-model="vatribuiridunidade">
                                    <label class="custom-control-label" for="cbatribuiridunidade"></label>
                                </div>
                            </div>                                                        
                            <div class="col-md-5">
                                <span class="lblselect2">Unidade:</span>
                                <select id="cbunidadecampos" data-placeholder="Selecione uma opção"
                                    v-model="vidunidadecampos" v-bind:disabled="!vatribuiridunidade"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridmarca" v-model="vatribuiridmarca">
                                    <label class="custom-control-label" for="cbatribuiridmarca"></label>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <span class="lblselect2">Marca:</span>
                                <select id="cbmarcacampos" data-placeholder="Selecione uma opção"
                                    v-model="vidmarcacampos" v-bind:disabled="!vatribuiridmarca"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridgrupo" v-model="vatribuiridgrupo">
                                    <label class="custom-control-label" for="cbatribuiridgrupo"></label>
                                </div>
                            </div>                            
                            <div class="col-md-5">
                                <span class="lblselect2">Grupo:</span>
                                <select id="cbgrupocampos" data-placeholder="Selecione uma opção"
                                    v-model="vidgrupocampos" v-bind:disabled="!vatribuiridgrupo"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridsubgrupo" v-model="vatribuiridsubgrupo">
                                    <label class="custom-control-label" for="cbatribuiridsubgrupo"></label>
                                </div>
                            </div>                            
                            <div class="col-md-5">
                                <span class="lblselect2">Subgrupo:</span>
                                <select id="cbsubgrupocampos" data-placeholder="Selecione uma opção"
                                    v-model="vidsubgrupocampos" v-bind:disabled="!vatribuiridsubgrupo"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirsetor" v-model="vatribuirsetor">
                                    <label class="custom-control-label" for="cbatribuirsetor"></label>
                                </div>
                            </div>                            
                            <div class="col-md-5">
                                <span class="lblselect2">Setor:</span>
                                <select id="cbsetorprodutoatribuir" data-placeholder="Selecione uma opção"
                                    v-model="vidsetorprodutoatribuir" v-bind:disabled="!vatribuirsetor"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                            
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridncm" v-model="vatribuiridncm">
                                    <label class="custom-control-label" for="cbatribuiridncm"></label>
                                </div>
                            </div>                            
                            <div class="col-md-11">
                                <span class="lblselect2">NCM:</span>
                                <select id="cbncmcampos" data-placeholder="Selecione uma opção"
                                    v-model="vidncmcampos" v-bind:disabled="!vatribuiridncm"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridcest" v-model="vatribuiridcest">
                                    <label class="custom-control-label" for="cbatribuiridcest"></label>
                                </div>
                            </div>                            
                            <div class="col-md-11">
                                <span class="lblselect2">CEST:</span>
                                <select id="cbcestcampos" data-placeholder="Selecione uma opção"
                                    v-model="vidcestcampos" v-bind:disabled="!vatribuiridcest"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>      
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuircomis" v-model="vatribuircomis">
                                    <label class="custom-control-label" for="cbatribuircomis"></label>
                                </div>
                            </div>                            
                            <div class="col-md-11">
                                <label for="edcomis">A. de comissão %:</label>
                                <money type="text" class="form-control form-control-sm" id="edcomis"
                                        v-model="valcomis" v-bind="money" v-bind:disabled="!vatribuircomis"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>                                                                                                             
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card" style="margin-top: 15px;">
                                    <div class="card-header card-in text-center" style="padding: 5px;">LOCALIZAÇÃO</div>
                                    <div class="card-body" style="padding: 5px 15px 15px 15px;">
                                        <div class="row">
                                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                                    <input type="checkbox" class="custom-control-input" id="cbatribuirlocalizacao" v-model="vatribuirlocalizacao">
                                                    <label class="custom-control-label" for="cbatribuirlocalizacao"></label>
                                                </div>
                                            </div>                                                        
                                            <div class="col-md-11">
                                                <span class="lblselect2">Filial:</span>
                                                <select id="cbfilialatribuirloc" data-placeholder="Selecione uma opção"
                                                    v-model="vidfilialatribuirloc" v-bind:disabled="!vatribuirlocalizacao"
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>                                             
                                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                            </div>                                                                                    
                                            <div class="col-md-11">
                                                <span class="lblselect2">Localização:</span>
                                                <select id="cblocalizacaoatribuir" data-placeholder="Selecione uma opção"
                                                    v-model="vidlocalizacaoatribuir" v-bind:disabled="!vatribuirlocalizacao"
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>														
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdatribuircampos()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div>
        <!-- Atribuir tabela --> 
        <div class="modal fade" id="mdatribuirtabela" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir tabela de preço à produtos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">                                                       
                            <div class="col-md-7">
                                <span class="lblselect2">Tabela:</span>
                                <select id="cbtabelaatribuir" data-placeholder="Selecione uma opção"
                                    v-model="vidtabelaatribuir"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-5">
                                <label for="cbtipoatribuirtabela">Atribuir:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbtipoatribuirtabela" v-model="vtipoatribuirtabela">
                                    <option value="0">Margem em cima do custo</option>
                                    <option value="1">Valor</option>
                                </select>
                            </div>
                            <div v-show="parseInt(vtipoatribuirtabela) === 1" class="col-sm-12 col-md-3 col-lg-3">
                                <label for="edprecoatribuir">Valor:</label>
                                <money type="text" class="form-control form-control-sm" id="edprecoatribuir"
                                        v-model="vprecoatribuir" v-bind="money" 
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>                                                        
                            <div v-show="parseInt(vtipoatribuirtabela) === 0" class="col-sm-12 col-md-3 col-lg-3">
                                <label for="edmrgtabelaatribuir">Mrg(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edmrgtabelaatribuir"
                                        v-model="vmrgtabelaatribuir" v-bind="money" 
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="edcomissaotabelaatribuir">Comissão(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edcomissaotabelaatribuir"
                                        v-model="vcomissaotabelaatribuir" v-bind="money"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="edqtdmintabelaatribuir">Desconto %:</label>
                                <money type="text" class="form-control form-control-sm" id="edqtdmintabelaatribuir"
                                        v-model="vqtdmintabelaatribuir" v-bind="money"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div> 													
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="eddescontotabelaatribuir">Qtd. Mínima:</label>
                                <money type="text" class="form-control form-control-sm" id="eddescontotabelaatribuir"
                                        v-model="vdescontotabelaatribuir" v-bind="money"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>                                                                                                                          
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdatribuirtabela()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div> 
        <!-- Geração de arquivos --> 
        <div class="modal fade" id="mdgerararquivo" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-file" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Geração de arquivos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">                        
                        <div class="row">          
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="cbtipoarquivo">Tipo de arquivo:</label>
                                <select name="cbtipoarquivo" class="form-control form-control-sm" id="cbtipoarquivo" v-model="vtipoarquivo">
                                    <option value="0">Balanças</option>
                                    <option value="1">Buscador de preços</option>
                                    <option value="2">Exportar cadastros</option>
                                </select>
                            </div>                                                                         
                            <div v-show="parseInt(vtipoarquivo) < 2" class="col-md-12">
                                <span class="lblselect2">Tabela:</span>
                                <select id="cbtabelaarquivo" data-placeholder="Selecione uma opção"
                                    v-model="vidtabelaarquivo"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div v-show="parseInt(vtipoarquivo) === 2" class="col-md-12">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialarquivo" data-placeholder="Selecione uma opção"
                                    v-model="vidfilialarquivo"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div v-show="parseInt(vtipoarquivo) === 2" class="col-md-12">
                                <span class="lblselect2">NCM:</span>
                                <select id="cbncmarquivo" data-placeholder="Selecione uma opção"
                                    v-model="vidncmarquivo" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div v-show="parseInt(vtipoarquivo) === 2" class="col-md-12">
                                <span class="lblselect2">Classe:</span>
                                <select id="cbclassearquivo" data-placeholder="Selecione uma opção"
                                    v-model="vidclassearquivo" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                            
                            <div v-show="parseInt(vtipoarquivo) === 2" class="col-md-12">
                                <span class="lblselect2">Estoque:</span>
                                <select id="cbestoquearquivo" data-placeholder="Selecione uma opção"
                                    v-model="videstoquearquivo"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                                                                                    
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">Marca:</span>
                                <select id="cbmarcaarquivo" v-model="vidmarcaarquivo"
                                        data-placeholder="Selecione uma marca"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">Grupo:</span>
                                <select id="cbgrupoarquivo" v-model="vidgrupoarquivo"
                                        data-placeholder="Selecione um grupo"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">Subgrupo:</span>
                                <select id="cbsubgrupoarquivo" v-model="vidsubgrupoarquivo"
                                        data-placeholder="Selecione um subgrupo"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">Setor:</span>
                                <select id="cbsetorarquivo" v-model="vidsetorarquivo"
                                        data-placeholder="Selecione um setor" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>  
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="cbstprorquivo">Sit.:</label>
                                <select name="cbstprorquivo" class="form-control form-control-sm" id="cbstprorquivo" v-model="vstproarquivo" title="Situação dos produtos">
                                    <option value="0">Inativos</option>
                                    <option value="1">Ativos</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div> 
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="cbfracionadoarquivo">Frac.:</label>
                                <select name="cbfracionadoarquivo" class="form-control form-control-sm" id="cbfracionadopesq" v-model="vfracionadoarquivo" title="Condição para exibição dos produtos fracionados">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>                                                       
                            <div v-show="parseInt(vtipoarquivo) === 0" class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cblayoutbalanca">Layout arquivo:</label>
                                <select name="cblayoutbalanca" class="form-control form-control-sm" id="cblayoutbalanca" v-model="vlayoutbalanca">
                                    <option value="0">Filizola</option>
                                    <option value="1">Toledo</option>
                                </select>
                            </div>          
                            <div v-show="parseInt(vtipoarquivo) === 2" class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbestoquearquivo">Estoque:</label>
                                <select name="cbestoquearquivo" class="form-control form-control-sm" id="cbestoquearquivo" v-model="vestoquearquivo">
                                    <option value="0">Com saldo</option>
                                    <option value="1">Sem saldo</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>                                                                                                                                    
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdgerararquivo()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div>
        <!-- Menu do produto --> 
		<div class="modal fade" id="mdmenuproduto" tabindex="-1">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ mtdformatarzeros(produtomenu.id, 8) }}</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdalterar(produtomenu)" data-dismiss="modal"><i class="fa fa-edit"></i> EDITAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdexcluir(produtomenu)" data-dismiss="modal"><i class="fa fa-trash"></i> REMOVER</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdclonar(produtomenu)" data-dismiss="modal"><i class="fa fa-clone"></i> CLONAR</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdajustarestoque(produtomenu)" data-dismiss="modal"><i class="fa fa-cubes"></i> AJUSTAR</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdvisualizarestoque(produtomenu)" data-dismiss="modal"><i class="fa fa-cube"></i> ESTOQUE(S)</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdvisualizarfornecedores(produtomenu)" data-dismiss="modal"><i class="fa fa-user-secret"></i> FORNECEDORES</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Fechar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>

        <!-- Consulta por códigos --> 
        <div class="modal fade" id="mdconsultaporcodigo" tabindex="-1">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-search" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Consultar produtos por código</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row"> 
							<div class="col-sm-12 col-md-8 col-lg-8">
								<label for="edcodigoconsultar">Informe o código à consultar:</label>
								<div class="input-group" style="z-index: 1;">
                                    <div class="input-group-append" id="dv-btn-camera">
                                        <a href="#" class="btn btn-success btn-sm btn-grupo-pesq-left" role="button" @click.prevent="mtdscannearcode()"><i class="fa fa-barcode" style="padding-top: 3px;"></i></a>
                                    </div>
									<input type="text" class="form-control form-control-sm" id="edcodigoconsultar" v-model="pcodigoconsultar" maxlength="20" v-on:keyup.13="mtdlistarprodutosporcodigo()" style="text-transform: uppercase;">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdlistarprodutosporcodigo()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
									</div>
								</div>
							</div>
                            <div class="col-lg-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                        <thead class="thead-light">
                                        <tr>
                                            <th>ID interno:</th>
                                            <th>Nome de referência:</th>
                                            <th>Und:</th>
                                            <th>ID interno:</th>
                                            <th>Referência:</th>                                            
                                            <th width="160px" style="text-align: center;">Opções</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(produto, index) in lstprodutoconsultacodigo" v-bind:key="index">
                                                <td>{{ produto.codigo }}</td>
                                                <td>{{ produto.descricao }}</td>
                                                <td>{{ produto.und }}</td>
                                                <td>{{ produto.id }}</td>
                                                <td>{{ produto.referência }}</td>
                                                <td width="180px" class="center" style="text-align: center;">
                                                    <a class="btn btn-primary btn-sm btn-opcrud ajt-btn" data-dismiss="modal" href="#"
                                                    v-bind:disabled="ativadesativa" @click.prevent="mtdalterar(produto)"><i class="fa fa fa-edit"></i></a>
                                                    <a class="btn btn-secondary btn-sm btn-opcrud ajt-btn" data-dismiss="modal" href="#"
                                                    v-bind:disabled="ativadesativa" @click.prevent="mtdajustarestoque(produto)"><i class="fa fa fa-cubes"></i></a>
                                                    <a class="btn btn-warning btn-sm btn-opcrud ajt-btn" href="#"
                                                    v-bind:disabled="ativadesativa" @click.prevent="mtdvisualizarestoque(produto)"><i class="fa fa-cube"></i></a>
                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" data-dismiss="modal" href="#"
                                                    v-bind:disabled="ativadesativa" @click.prevent="mtdexcluir(produto)"><i class="fa fa-trash"></i></a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>                                                                                                                                                          
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div>

        <!-- Modal do scannercode -->        
        <div class="modal static" id="mdlscannercode"  >
            <div class="modal-dialog modal-lg static">
                <div class="modal-content">         
                    <div id="#dvcamera">
                        <v-quagga v-if="mostrandomodal==true" :onDetected="mtdprocessacodbar" :readerSize="readerSize" 
                            :readerTypes="
                            ['code_128_reader',
                            'ean_reader', 
                            'ean_8_reader']">
                        </v-quagga>
                    </div>
                </div>
            </div>
        </div>

        <!-- Operações com tabelas --> 
        <div class="modal fade" id="mdoperacoestabelas" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-exchange" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Operações com tabelas</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-8 col-lg-8">
                                <label for="cbtpoperacao">Tipo de operação:</label>
                                <select name="cbtpoperacao" class="form-control form-control-sm" id="cbtpoperacao" v-model="otpoperacao">
                                    <option value="0">Atribuir tabela baseada em outra</option>
                                    <option value="1">Remover tabela</option>
                                    <option value="2">Atribuir tabela com base no preço de custo</option>
                                    <option value="3">Ajustar valor da tabela</option>
                                </select>
                            </div>                                                                                   
                            <div v-show="parseInt(otpoperacao) === 0 || parseInt(otpoperacao) === 3" class="col-md-12">
                                <span class="lblselect2">Tabela origem:</span>
                                <select id="cbtabelaorigem" data-placeholder="Selecione uma opção"
                                    v-model="oidtabelaorigem"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div v-show="parseInt(otpoperacao) !== 3" class="col-md-12">
                                <span class="lblselect2">Tabela à atribuir:</span>
                                <select id="cbtabelaatribuirop" data-placeholder="Selecione uma opção"
                                    v-model="oidtabelaatribuirop"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                                                                               
                            <div v-show="parseInt(otpoperacao) === 0 || parseInt(otpoperacao) === 2" class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edmargematribuirop">Margem(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edmargematribuirop" v-model="omrgtabelaatribuirop"
                                        v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
                            </div>   
                            <div v-show="parseInt(otpoperacao) === 3" class="col-sm-12 col-md-8 col-lg-8">
                                <label for="cbtpfatorajuste">Tipo de operação:</label>
                                <select name="cbtpfatorajuste" class="form-control form-control-sm" id="cbtpfatorajuste" v-model="otpfatorajuste">
                                    <option value="0">Percentual(%)</option>
                                    <option value="1">Valor($)</option>
                                </select>
                            </div>                            
							<div v-show="parseInt(otpoperacao) === 3" class="col-sm-12 col-md-4 col-lg-4">
                                <label v-if="parseInt(otpfatorajuste) === 0" for="edfatoratribuirop">Fator(%):</label>
                                <label v-else for="edfatoratribuirop">Fator($):</label>
                                <money type="text" class="form-control form-control-sm" id="edfatoratribuirop" v-model="ofatortabelaajuste"
                                        v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
                            </div>                                                                                                               
                        </div>
                        <div class="row" style="margin-top: 10px;">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-header card-in" style="padding: 5px;">OPÇÕES DE FILTROS</div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <span class="lblselect2">Marca:</span>
                                                <select id="cbmarcaatribuirop" data-placeholder="Selecione uma opção"
                                                    v-model="oidmarcaatribuirop"
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-md-6">
                                                <span class="lblselect2">Grupo:</span>
                                                <select id="cbgrupoatribuirop" data-placeholder="Selecione uma opção"
                                                    v-model="oidgrupoatribuirop"
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>                            
                                            <div class="col-md-6">
                                                <span class="lblselect2">Subgrupo:</span>
                                                <select id="cbsubgrupoatribuirop" data-placeholder="Selecione uma opção"
                                                    v-model="oidsubgrupoatribuirop" 
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>                                                                        
                                            <div class="col-md-6">
                                                <span class="lblselect2">Setor:</span>
                                                <select id="cbsetoratribuirop" data-placeholder="Selecione uma opção"
                                                    v-model="oidsetoratribuirop" 
                                                    data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>                                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdconfirmaroperacaotabelas()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div>
        
        <!-- Visualiza o imposto sobre o valor -->
        <div class="modal fade" id="mdimpostovalor" tabindex="-1">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-dollar" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Imposto sobre o valor</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row"> 
                            <div class="col-12">
                                <label for="edivalorbase">Valor base:</label>
                                <div class="input-group" style="z-index: 1;">
                                    <money type="text" class="form-control form-control-sm" id="edivalorbase" v-model="ivalorbase"
                                            v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
                                    <div class="input-group-append" style="height: 31px;">
                                        <button class="btn btn-primary" title="Atualizar cálculo" @click.prevent="mtdcalculavalorimpostoclasse()" style="border-top-left-radius: 0px!important; border-bottom-left-radius: 0px!important;"><i class="fa fa-refresh"></i></button>
                                    </div>                                            
                                </div>
                            </div>
                            <div class="col-12">
                                <span class="lblselect2">Classe:</span>
                                <select id="cbiclasse" data-placeholder="Selecione uma opção"
                                    v-model="iidclasse"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                            
                            <div class="col-12">
                                <label for="edivalorimposto">Imposto:</label>
                                <input type="text" class="form-control form-control-sm text-info" id="edivalorimposto"
                                    v-bind:value="mtdformatavalordecimal(parseFloat(ivalorimposto), 2)"
                                    data-bv-group=".group" style="text-align:right;" disabled>
                            </div>                            
                            <div class="col-12">
                                <label for="edivalorbase">Valor com imposto:</label>
                                <money type="text" class="form-control form-control-sm" id="edivalorbase" v-model="ivalorcomimposto"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" disabled></money>
                            </div>                                                                                                                                                                                                                                  
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdselecionavalorbase()" style="width: 100px;"><i class="fa fa-check"></i> Ok</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div> 
        
        <!-- Atribuir margem para preço de venda na composição do custo -->
        <div class="modal fade" id="mdatribuirmargem" tabindex="-1">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-percent" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir margem</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <label for="edaprcusto">Pr. Custo:</label>
                                <money type="text" class="form-control form-control-sm" id="edaprcusto" v-model="vprcusto"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" disabled></money>
                            </div>                             
                            <div class="col-12">
                                <label for="edamargem">Margem(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edamargem" v-model="amargem"
                                        v-bind="money" data-bv-group=".group" style="text-align:right;" @change.native="mtdcalculamargemprvendamedio()"></money>
                            </div>                          
                            <div class="col-12">
                                <label for="edavalor">Valor:</label>
                                <money type="text" class="form-control form-control-sm" id="edavalor" v-model="avalor"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" disabled></money>
                            </div>                                                                                                                                                                                                                                  
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdaplicarvalorprvenda()" style="width: 100px;"><i class="fa fa-check"></i> Aplicar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div>        

        <!-- Informar o valor para calcular o percentual da margem de desconto promocional -->
        <div class="modal fade" id="mdinformarvalordescpromocional" tabindex="-1">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-percent" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff; font-size: 12px; margin-top: 5px;">Calcular percentual do descto promocional</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <label for="edvalorsemdescpromocional">Valor sem desc. promocional:</label>
                                <money type="text" class="form-control form-control-sm" id="edvalorsemdescpromocional" v-model="avalorsemdescpromocional"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" disabled></money>
                            </div>                            
                            <div class="col-12">
                                <label for="edvalorcomdescpromocional">Valor com desc. promocional:</label>
                                <money type="text" class="form-control form-control-sm" id="edvalorcomdescpromocional" v-model="avalorcomdescpromocional"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" @change.native="mtdcalcularvalordescpromocional()"></money>
                            </div>                             
                            <div class="col-12">
                                <label for="edamargem">Percentual do desconto(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edamargem" v-model="amargemdescpromocional"
                                        v-bind="money" data-bv-group=".group" style="text-align:right;" disabled></money>
                            </div>                                                                                                                                                                                                                                  
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdaplicarpercentualdescpromocional()" style="width: 100px;"><i class="fa fa-check"></i> Aplicar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div>  
        <!-- gerar catalogo de produtos -->
        <div class="modal fade container-fluid" id="mdcatalogo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Gerando catalogo</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="col-12">
                    <span class="lblselect2">Filial:</span>
                    <select id="cbfilialcatalogo" data-placeholder="Selecione uma opção"
                        v-model="vidfilialcatalogo"
                        data-allow-clear="true" style="width:100%;">
                    </select>
                </div>
                <div class="col-12">
                    <span class="lblselect2">Tabela:</span>
                    <select id="cbtabelacatalogo" data-placeholder="Selecione uma opção"
                        v-model="vidtabelacatalogo"
                        data-allow-clear="true" style="width:100%;">
                    </select>
                </div> 
                <div class="col-12">
                    <div class="row">
                        <div class="col-6">
                            <span class="lblselect2">Grupo:</span>
                            <select id="cbgrupocatalogo" data-placeholder="Selecione uma opção"
                                v-model="vidgrupocatalogo"
                                data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div class="col-6">
                            <span class="lblselect2">Subgrupo:</span>
                            <select id="cbsubgrupocatalogo" data-placeholder="Selecione uma opção"
                                v-model="vidsubgrupocatalogo"
                                data-allow-clear="true" style="width:100%;">
                            </select>
                        </div> 
                        <div class="col-7">
                            <span class="lblselect2">Marca:</span>
                            <select id="cbmarcacatalogo" data-placeholder="Selecione uma opção"
                                v-model="vidmarcacatalogo"
                                data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div class="col-5">
                            <label for="cbopestoque">Referencia:</label>
                            <select class="form-control form-control-sm" id="cbopestoque" v-model="opref">
                                <option value="0">Sim</option>
                                <option value="1">Não</option>                           
                            </select>
                        </div>
                    </div>
                </div>
              
                <div class="col-12">
                    <div class="row">
                        <div class="col-5">
                            <label for="cbopestoque">Preço:</label>
                            <select class="form-control form-control-sm" id="cbopestoque" v-model="oppreco">
                                <option value="0">Geral</option>
                                <option value="1">Auxiliar</option>                           
                            </select>
                        </div> 
                        <div class="col-5">
                            <label for="cbopestoque">Valores:</label>
                            <select class="form-control form-control-sm" id="cbopestoque" v-model="opvalor">
                                <option value="0">Sim</option>
                                <option value="1">Não</option>                           
                            </select>
                        </div>  

                        <div style="padding-top: 20px;" class="col-2">
                            <button  v-show="vlink === ''" type="button" @click.prevent="mtdgerarlink()" class="btn btn-primary btn-sm btn-block" ><i class="fa fa-link" aria-hidden="true"></i></button>
                            <button v-show="vlink !== ''" type="button" @click.prevent="mtdcopiarlink()" class="btn btn-primary btn-sm ver" ><i class="fa fa-clipboard"></i></button>
                        </div>  
                    </div>
                </div>  
              
                

                <div  v-if="vlink!==''"  style="padding-top: 10px;" class="col-sm-12 col-md-12 col-lg-12">
                    <div class="col-sm-12">
                    </div>	
                    <label for="edobsmov">Link gerado</label>
                    <div class="form-group">
                        <textarea class="form-control"
                            rows="3"  v-model="vlink" v-bind:disabled="vhab" id="textolink"></textarea>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button v-show="vlink !== ''" type="button" @click.prevent="abrirlink()" class="btn btn-sm ver" >Abrir</button>
                <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Fechar</button>
            </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import VisualizadorEstoque from '../components/cmpvisualizadorestoque'
    import FornecedoresProduto from '../components/cmpfornecedoresproduto'
    import util from '../utilitarios/util.js'
    
    export default {
        name: 'cadprodutos',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb'            : BreadCrumb,
            'visualizadorestoque'   : VisualizadorEstoque,            
            'fornecedoresproduto'   : FornecedoresProduto
        },
        data: function() {
            return {
                //variáveis do leitor de código de barras
                mostrandomodal      : false, 
                readerSize: {
                    width: 640,
                    height: 480
                },
                detecteds    : [],	
                produto      : [],   
                produtomenu  : [],   
                lstprodutos  : [],
                pfiltro      : 1,
                pconteudo     : '',
                pespecificacao: '',
                pstpro       : 2,
                pidmarca     : null,
                pidgrupo     : null,
                pidsubgrupo  : null,
                pidsetor     : null,
                pidncm       : null,   
                pfracionado  : 2,
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,
                pmaisfiltros : false,
                pdtini       : util.DataAtual(true),
				pdtfim       : util.DataAtual(true),
                pfiltrocadastropesq : 2,
                pfiltroncmpesq      : 2,      	

                //variáveis do crud
                opcrud                  : 0,
                vid                     : '',
                vdescricao              : '',
                vreferencia             : '',
                vstpro                  : 1,
                vdtcadastro             : '',
                vdtultimavenda          : null,
                vidultimavenda          : 0,
                vidmarca                : null,
                vidgrupo                : null,
                vidsubgrupo             : null,
                vidsetorproduto         : null,
                vund                    : null,
                vdiasvalidade           : 0,
                vreg                    : 0,
                vfracionado             : 0,
                vtipo                   : 0,
                vcontrolaserial         : 0,
                vestoqueminimo          : 0,
                vestoquemaximo          : 0,
                vespecificacao          : '',
                vprcompra               : 0,
                vpipi                   : 0,
                vpicms                  : 0,
                vpfrete                 : 0,
                vppis                   : 0,
                vfatcomis               : 0,
                vpcofins                : 0,
                vpoutros                : 0,
                vbcst                   : 0,
                vcalculasubstributaria  : 0,
                vpst                    : 0,
                vvst                    : 0,
                vprcusto                : 0,
                vcalcularprvendamedio   : false,
                vmargemprcusto          : 0,
                vprvendamedio           : 0,
                vidncm                  : null,
                vidcest                 : null,
                vidsituacaotributaria   : null,
                vtipoproduto            : 0,
                vorigemproduto          : 0,
                vprodutoespecifico      : 0,
                vpathimagens            : '',
                vobservacoes            : '',
                lstTabelasPrecos        : [],
                lstCodigos              : [],
                lstLocalizacaoProduto   : [],
                lstClassesProduto       : [],
                lstsimilaridades        : [],

                //variáveis do cashback
                vvlcreditoacumulaavista : 0,
                vvlcreditoacumulaaprazo : 0,               

                //variaveis geração de catalogo
                vidfilialcatalogo       : null,
                vidtabelacatalogo       : null,
                vlink                   : '',
                vhab                    : true,
                oppreco                 : 0,
                opvalor                 : 0,  //0 - sim    1 - não
                vidmarcacatalogo        : null,
                vidgrupocatalogo        : null,
                vidsubgrupocatalogo     : null,
                opref                   : 0, 

                //variável para habilitação dos campos
                ativadesativa           : true,

                //variáveis da rotina de tabelas de preços
                habdestab               : false,
                voptabela               : 1,
                vidtabelapreco          : null,
                vmrgtabela              : 0,
                vvltabela               : 0,
                vvlnf                   : 0,
                vcomissaotabela         : 0,
                vqtdmintabela           : 0,
                vdescontotabela         : 0,            
                vvldescpromocional      : 0,
                vvlvizu                 : 0,

                //códigos
                vcodigoinc              : '',
                ///////////////////////////////////
                //localizações
                vidfiliallocalizacao : null,
                vidlocalizacao       : null,
                //classes
                vidclasse            : null,
                vidfilialclasse      : null,

                //similaridades
                vreferenciasimilarinc: '',

                //rotina imagens
                arqimgselecionado    : null,
                lstImagens           : [],

                //pega o path do diretorio padrão das imagens
                pathimgview          : this.$store.state.configpaths.pathimagens,

                //ajuste de estoque
                vidfilialajuste      : null,
                vidproduto           : null,
                vdescpro             : '',
                vunidadepro          : '',
                videstoque           : null,
                vqtdmov              :  1,
                vvlmov               :  0,
                vdocmov              : '', 
                vdtmov               : util.DataAtual(true),
                vtpmov               :  0, 
                vperda               :  0,
                vobsmov              : '',
                vqtdanterior         :  0,
                vundanterior         : '',
                vqtdatualizada       :  0,
                msgTitAjuste         : '',
                vprofracionado       :  0,

                //atribuição de classe para os produtos
                vopcaoclasseatribuir: 0,
                vidfilialatribuir   : null,
                vidclasseatribuir   : null,
                vatribuitodosprodutos: false,

                //atribuição de campos
                vatribuirsituacao   : false,
                vsituacaocampos     : 1,
                vatribuirreferencia : false,
                vreferenciacampos   : '',

                vatribuirfracionado : false,
                vfracionadocampos   : 1,

                vatribuiridunidade  : false,
                vidunidadecampos    : null,

                vatribuiridmarca    : false,
                vidmarcacampos      : null,

                vatribuiridgrupo    : false,
                vidgrupocampos      : null,

                vatribuiridsubgrupo : false,
                vidsubgrupocampos   : null,

                vatribuiridncm      : false,
                vidncmcampos        : null,

                vatribuiridcest     : false,
                vidcestcampos       : null,   
                
                vatribuircomis      : false,//guga atribuir comissão
                valcomis            : 0,


                vatribuirlocalizacao  : false,
                vidfilialatribuirloc  : null,
                vidlocalizacaoatribuir: null,

                vatribuirsetor        : false,
                vidsetorprodutoatribuir: null,
                

                consultarprodutos   : false,

                //variaveis atribuição de tabelas
                vidtabelaatribuir               : null,
                vtipoatribuirtabela             : 0,    
                vmrgtabelaatribuir              : 0,
                vprecoatribuir                  : 0,
                vcomissaotabelaatribuir         : 0,
                vqtdmintabelaatribuir           : 0,
                vdescontotabelaatribuir         : 0,                

                //id do produto para visualização
                idprodutoestoque    : 0,
                descproestoque      : '',

                //para visualização dos fornecedores
                idprodutofornecedores    : 0,
                descprofornecedores       : '',                

                //variável da importação
                vlimpardados            : false,
                arqselecionado          : null,
                vimportarcodigos        : false,
                vreconstruirchaves      : false, 
                
                //variáveis para geração de arquivos
                vtipoarquivo             : 0,   
                vidfilialarquivo         : null,
                vidncmarquivo            : null,
                vidclassearquivo         : null,
                videstoquearquivo        : null,   
                vidtabelaarquivo         : null,
                vidmarcaarquivo          : null,
                vidgrupoarquivo          : null,
                vidsubgrupoarquivo       : null,
                vidsetorarquivo          : null,
                vstproarquivo            : 0,
                vfracionadoarquivo       : 2,
                vlayoutbalanca           : 1,
                vestoquearquivo          : 2,

                //variaveis da consulta por código
                pcodigoconsultar        : '',
                lstprodutoconsultacodigo: [],

                //variáveis de operações com tabelas
                otpoperacao             : 0,
                oidtabelaorigem         : null,
                oidtabelaatribuirop     : null,
                omrgtabelaatribuirop    : 0,
                oidmarcaatribuirop      : null,
                oidgrupoatribuirop      : null,
                oidsubgrupoatribuirop   : null,
                oidsetoratribuirop      : null,
                otpfatorajuste          : 0,
                ofatortabelaajuste      : 0,

                lstfornecedoresproduto  : [],

                //cadastro da localização
                vnovalocalizacao        : false,
                vdescricaolocalizacao   : '',
                vidnovalocalizacao      : '',

                //variáveis para processar arquivo de códigos
                vnomearquivo            : '',

                //variáveis do calculo do imposto sobre o valor
                ivalorbase              : 0,
                iidclasse               : null,
                iclasse                 : [],
                ivalorimposto           : 0,
                ivalorcomimposto        : 0,

                //variáveis para atribuição da margem
                amargem                  : 0,
	            avalor                   : 0,

                //variáveis para atruibuir percentual do desconto promocional
                avalorsemdescpromocional : 0,
                avalorcomdescpromocional : 0,
                amargemdescpromocional   : 0,    
                
                //variáveis para exportação para o excel
                //caso queira exportar todo o conteúdo não informar o json_fields na declaração do componente
                lstprodutosexportar         : [],
                json_fields: {
                            'Código'        : 'id',
                            'Descricão'     : 'descricao',
                            'Und'           : 'und',
                            'Referência'    : 'referencia',
                            'Especifições'  : 'especificacao',
                            'Marca'         : 'descmarca',
                            'Grupo'         : 'descgrupo',
                            'Subgrupo'      : 'descsubgrupo',
                            'Setor'         : 'descsetor',
                            'Estoque mínimo': 'estoqueminimo',
                            'Estoque'       : 'quantidadeexp',
                            'Pr. Custo'     : 'prcustoexp'  ,
                            'Pr. Venda'     : 'prvendamedioexp',
                            'Localização'   : 'localizacao',
                            'NCM'           : 'idncm',
                            'CEST'          : 'idcest',
                            'cst'           : 'cst',
                            'Perc. ICMS'    : 'picms',
                            'Perc. IPI'     : 'pipi',
                            'Perc. COFINS'  : 'pcofins',
                            'Perc. ST'      : 'pst',
                            'Valor. ST'     : 'vst',
                            'cfop'          : 'cfop',
                            'cstpiscofins'  : 'cstpiscofins',
                            'ppis'          : 'ppis',
                            'pcofins'       : 'pcofins',
                            'ppisst'        : 'ppisst',
                            'pcofinsst'     : 'pcofinsst',
                            'codigobarras'  : 'codigobarras'
                },
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],                
                ///////////////////////////////                

				options: {
					format          : 'DD/MM/YYYY',
					useCurrent      : false,
					locale          : 'pt-BR'
				},                
                money: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                quantidade: {
                    decimal       : ',',
                    thousands     : '.',
                    prefix        : '',
                    precision     : 3,
                    masked        : false
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'PRODUTOS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-produto",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Situação",
                        name: "stpro",
                        sort: true,
                        slot_name: "situacao_produto"
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Und",
                        name: "und",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Referência",
                        name: "referencia",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Especificações",
                        name: "especificacao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Marca",
                        name: "descmarca",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Grupo",
                        name: "descgrupo",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Subgrupo",
                        name: "descsubgrupo",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Setor",
                        name: "descsetor",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Estoque",
                        name: "quantidade",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        slot_name: "slot_qtd_estoque",
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "NCM",
                        name: "idncm",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Preços",
                        name: "precos",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_precos",
                        row_classes: "def-col-slot-precos"
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    global_search: {
                        visibility: false,
                    },

                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdprocessanovocomcodigo(){
                var cod = this.pcodigoconsultar;
                this.mtdnovo();
                this.vcodigoinc = cod;
                this.mtdinccodigo();
                $("#mdconsultaporcodigo").modal('hide');
            },
            mtdescondescanner(){
                $("#mdlscannercode").modal('hide');
                this.mostrandomodal = false
            },	
            mtdprocessacodbar(data){
                var codpro = data.codeResult.code

                this.pcodigoconsultar = codpro
                this.mtdlistarprodutosporcodigo();
                this.mtdescondescanner();
            },
            mtdscannearcode(){
                $("#mdlscannercode").modal('show');
                this.mostrandomodal = true
            },
            abrirlink(){
                window.open(this.vlink, '_blank');
            },
            mtdcopiarlink(){
                let vself = this;
                this.vhab = false;
                let textoCopiado = document.getElementById("textolink");
                setTimeout(() => {
                    textoCopiado.select();
                    document.execCommand("copy");
                }, 100);
              
                setTimeout(() => {
                    vself.vhab = true;
                }, 500);  

                vself.$toastr.s('Copiado com sucesso!', 'Informação!');
            },
            mtdgerarlink(){
                if(this.vidfilialcatalogo === null){
                    this.$toastr.w('Informe a filial!', 'Atenção!');
                    return
                }
                if(this.vidtabelacatalogo === null){
                    this.$toastr.w('Informe a tabela de preço!', 'Atenção!');
                    return
                }

                var marca    = this.vidmarcacatalogo === null ? 0 : this.vidmarcacatalogo
                var grupo    = this.vidgrupocatalogo === null ? 0 : this.vidgrupocatalogo
                var subgrupo = this.vidsubgrupocatalogo === null ? 0 : this.vidsubgrupocatalogo

                this.vlink =    this.$store.state.configpaths.pathcontrole+'catalago/boss.php?idcliente='+
								this.$store.state.filialpadrao.idcliente+
								'&idtabelapreco='+this.vidtabelacatalogo+
                                '&adrserver=https://'+this.$store.state.usuario.adrsrv+'/'+
                                '&idfilial='+this.vidfilialcatalogo+
                                '&oppreco='+this.oppreco+
                                '&opvalor='+this.opvalor+
                                '&marca='+marca+
                                '&grupo='+grupo+
                                '&subgrupo='+subgrupo+
                                '&opref='+this.opref+
                                '&pathimgpro='+this.$store.state.configpaths.pathimgprodutos+this.$store.state.filialpadrao.idcliente;
            },
            mtdabremodalcatalogo(){
                $('#cbfilialcatalogo').val(null).trigger('change');
                $('#cbtabelacatalogo').val(null).trigger('change');
                $('#cbmarcacatalogo').val(null).trigger('change');
                $('#cbgrupocatalogo').val(null).trigger('change');
                $('#cbsubgrupocatalogo').val(null).trigger('change');
                this.vidfilialcatalogo       = null;
                this.vidtabelacatalogo       = null;
                this.vidmarcacatalogo        = null;
                this.vidgrupocatalogo        = null;
                this.vidsubgrupocatalogo     = null;
                this.opref                   = 0; 
                this.vlink                   = '';
                this.vhab                    = true;
                this.oppreco                 = 0;
                this.opvalor                 = 0;  //0 - sim    1 - não
                $('#mdcatalogo').modal('show');
            },
			mtdmostrarmenu(produto){				
				this.produtomenu = produto;
				$('#mdmenuproduto').modal('show');
			},  
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},                       
            mtdconsultarproduto(){
                this.consultarprodutos = true;
				let payload = {
					abrirtela    : true,
					idprodutoret : null				
				};
				this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);	                
            },
            mtdselecionarimagem(event){
                let vself = this;
                vself.arqimgselecionado = event.target.files[0];
                let loader      = vself.$loading.show();
                let localsalvar = vself.$store.state.configpaths.pathimgprodutos + vself.$store.state.filialpadrao.idcliente +'/'+ vself.vpathimagens;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqimgselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqimgselecionado.name},
                    {parametro: 'nomediferente',    valor  : 1},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('Imagem enviada com sucesso!', 'Informação!');
                        vself.lstImagens = [];
                        vself.lstImagens = response.data.arquivos;
                        vself.arqimgselecionado = null;
                        $('#ipselecionarimg').val('');

                    }else{
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });                

            },
            mtdexcluirimgproduto(patharquivo){
                let vself = this;
                let loader       = vself.$loading.show();
                let localarquivo = vself.$store.state.configpaths.pathimgprodutos + vself.$store.state.filialpadrao.idcliente +'/'+ vself.vpathimagens;

                let parametros      = [
                    {parametro: 'op',               valor  : "excluirarquivo"},
                    {parametro: 'patharquivo',      valor  : patharquivo},
                    {parametro: 'localarquivo',     valor  : localarquivo}
                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('Imagem excluída com sucesso!', 'Informação!');
                        vself.lstImagens = [];
                        vself.lstImagens = response.data.arquivos;
                    }else{                        
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });                  
            },
            formatavalores:function (val) {
                return util.formatarvalor(val, '');
            },
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},            
            mtdselect2_def(){
                let vself = this;             
                //selects das pesquisas
                $('#btselecionararquivo').change(function() {
                    vself.mtdrotinaprocessacodigos();
                }); 
                $('#mdlscannercode').on('hide.bs.modal', function (e) {
                    vself.mostrandomodal = false
                });                
                $("#cbmarcapesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidmarca = $("#cbmarcapesq").val();
                    vself.mtdlimpar_listagem();
                });
                $("#cbgrupopesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidgrupo = $("#cbgrupopesq").val();
                    vself.mtdlimpar_listagem();
                });
                $("#cbsubgrupopesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsubgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidsubgrupo = $("#cbsubgrupopesq").val();
                    vself.mtdlimpar_listagem();
                });
                $("#cbsetorpesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsetoresprodutos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidsetor = $("#cbsetorpesq").val();
                    vself.mtdlimpar_listagem();
                });
                $("#cbncmpesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbncms',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidncm = $("#cbncmpesq").val();
                });                

                //selects do crud
                $("#cbunidade").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbunidades',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vund = $("#cbunidade").val();
                });
                $("#cbmarca").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidmarca = $("#cbmarca").val();
                });
                $("#cbgrupo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidgrupo = $("#cbgrupo").val();
                });
                $("#cbsubgrupo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsubgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsubgrupo = $("#cbsubgrupo").val();
                });
                $("#cbsetorproduto").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsetoresprodutos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsetorproduto = $("#cbsetorproduto").val();
                });

                //select da tabelela de preços
                $("#cbtabelapreco").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidtabelapreco = $("#cbtabelapreco").val();
                    if (vself.vidtabelapreco != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.vidtabelapreco},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtabelasprecos.php');
                        retorno.then(function (response) {
                            if (parseInt(vself.voptabela) === 1){
                                vself.vmrgtabela = parseFloat(response.data[0].margem); 
                                vself.vcomissaotabela = parseFloat(response.data[0].comissao); 
                                vself.mtdcalculaprtabela(); 
                            }                          
                            loader.hide();
                        }).catch(function (response) {
                            console.log(response);
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.vmrgtabela = 0;
                        vself.vvlvtabela = 0;
                    }
                });

                //selects das localizações
                $("#cbfiliallocalizacao").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfiliallocalizacao = $("#cbfiliallocalizacao").val();
                });
                $("#cblocalizacao").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tblocalizacoes',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidlocalizacao = $("#cblocalizacao").val();
                });

                //selects da parte fiscal
                $("#cbncm").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbncms',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidncm = $("#cbncm").val();
                });
                $("#cbcest").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcests',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcest = $("#cbcest").val();
                });                 
                $("#cbsituacaotributaria").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsituacaotributaria',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsituacaotributaria = $("#cbsituacaotributaria").val();
                });

                //selects das classes
                $("#cbclasse").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbclassesimpostos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidclasse = $("#cbclasse").val();
                });                
                $("#cbfilialclasse").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfilialclasse = $("#cbfilialclasse").val();
                }); 
				$("#cbestoque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.videstoque = $("#cbestoque").val();
                    
                    if (vself.videstoque != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'buscarestoque'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and ep.idproduto='+vself.vidproduto+ ' and ep.idestoque='+vself.videstoque}
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                        retorno.then(function (response) {
                            vself.vqtdanterior = parseFloat(response.data[0].quantidade);
                            loader.hide();
                        }).catch(function (response) {
                            console.log(response);
                            loader.hide();
                        });
                    } else {
                        vself.vqtdanterior = 0;
                    }                    
                });
				$("#cbfilialajuste").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfiliais',
								c1: 'codfil',
								c2: 'descfil'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilialajuste = $("#cbfilialajuste").val();
				});                                

                //define métodos ao sair dos campos
                $("#edmrgtabela").blur(function(){
                    vself.mtdcalculaprtabela();
                });
                $("#edvltabela").blur(function(){
                    vself.mtdcalculamrgtabela();
                });                

                //atribuição de classes
                $("#cbclasseatribuir").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbclassesimpostos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidclasseatribuir = $("#cbclasseatribuir").val();
                });                
                $("#cbfilialatribuir").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfilialatribuir = $("#cbfilialatribuir").val();
                });
                
                //atribuição de tabelas
                $("#cbtabelaatribuir").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidtabelaatribuir = $("#cbtabelaatribuir").val();
                    if (vself.vidtabelaatribuir != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.vidtabelaatribuir},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtabelasprecos.php');
                        retorno.then(function (response) {
                            vself.vmrgtabelaatribuir = parseFloat(response.data[0].margem); 
                            loader.hide();
                        }).catch(function (response) {
                            console.log(response);
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.vmrgtabelaatribuir = 0;
                    }                    
                });

                $('#mdatribuirtabela').on('shown.bs.modal', function (e) {
					$('#cbtabelaatribuir').select2('open');
                });

                //atribuição de campos
                $('#mdatribuircampos').on('shown.bs.modal', function (e) {
					$('#cbatribuirsituacao').focus();
                });
                $("#cbunidadecampos").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbunidades',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidunidadecampos = $("#cbunidadecampos").val();
                });
                $("#cbmarcacampos").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidmarcacampos = $("#cbmarcacampos").val();
                });
                $("#cbgrupocampos").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidgrupocampos = $("#cbgrupocampos").val();
                });
                $("#cbsubgrupocampos").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsubgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsubgrupocampos = $("#cbsubgrupocampos").val();
                });
                $("#cbncmcampos").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbncms',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidncmcampos = $("#cbncmcampos").val();
                });
                $("#cbcestcampos").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcests',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcestcampos = $("#cbcestcampos").val();
                });	                            
                $("#cblocalizacaoatribuir").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tblocalizacoes',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidlocalizacaoatribuir = $("#cblocalizacaoatribuir").val();
                });            
                $("#cbfilialatribuirloc").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfilialatribuirloc = $("#cbfilialatribuirloc").val();
                });  
                
                $("#cbsetorprodutoatribuir").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsetoresprodutos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsetorprodutoatribuir = $("#cbsetorprodutoatribuir").val();
                });                
                
                //gerarção do arquivos
                $("#cbncmarquivo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbncms',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidncmarquivo = $("#cbncmarquivo").val();
                });  
                $("#cbclassearquivo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbclassesimpostos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidclassearquivo = $("#cbclassearquivo").val();
                });                
                $("#cbtabelaarquivo").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidtabelaarquivo = $("#cbtabelaarquivo").val();
                });            
                $("#cbmarcaarquivo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidmarcaarquivo = $("#cbmarcaarquivo").val();
                });
                $("#cbgrupoarquivo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidgrupoarquivo = $("#cbgrupoarquivo").val();
                });
                $("#cbsubgrupoarquivo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsubgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsubgrupoarquivo = $("#cbsubgrupoarquivo").val();
                });
                $("#cbsetorarquivo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsetoresprodutos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsetorarquivo = $("#cbsetorarquivo").val();
                });

                //operações com tabelas
                $("#cbtabelaatribuirop").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.oidtabelaatribuirop = $("#cbtabelaatribuirop").val();
                    if (vself.oidtabelaatribuirop != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.oidtabelaatribuirop},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtabelasprecos.php');
                        retorno.then(function (response) {
                            vself.omrgtabelaatribuirop = parseFloat(response.data[0].margem); 
                            loader.hide();
                        }).catch(function (response) {
                            console.log(response);
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.omrgtabelaatribuirop = 0;
                    }                    
                });
                $("#cbtabelaorigem").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.oidtabelaorigem = $("#cbtabelaorigem").val();
                });
                $("#cbmarcaatribuirop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.oidmarcaatribuirop = $("#cbmarcaatribuirop").val();
                });
                $("#cbgrupoatribuirop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.oidgrupoatribuirop = $("#cbgrupoatribuirop").val();
                });
                $("#cbsubgrupoatribuirop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsubgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.oidsubgrupoatribuirop = $("#cbsubgrupoatribuirop").val();
                });                                                            
                $("#cbsetoratribuirop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsetoresprodutos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.oidsetoratribuirop = $("#cbsetoratribuirop").val();
                }); 

                $("#cbfilialcatalogo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfilialcatalogo = $("#cbfilialcatalogo").val();
                    vself.vlink = '';
                }); 

                $("#cbmarcacatalogo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidmarcacatalogo = $("#cbmarcacatalogo").val();
                    vself.vlink = '';
                }); 
                $("#cbgrupocatalogo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidgrupocatalogo = $("#cbgrupocatalogo").val();
                    vself.vlink = '';
                }); 
                $("#cbsubgrupocatalogo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbsubgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidsubgrupocatalogo = $("#cbsubgrupocatalogo").val();
                    vself.vlink = '';
                }); 

                $("#cbtabelacatalogo").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbtabelasprecos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidtabelacatalogo = $("#cbtabelacatalogo").val();
                    vself.vlink = '';
                }); 

                $("#cbfilialarquivo").select2({
                        id: function (e) {return e.codfil},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'fantasia'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidfilialarquivo = $("#cbfilialarquivo").val();
                });
				
				$("#cbestoquearquivo").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.videstoquearquivo = $("#cbestoquearquivo").val();                   
                });

                $('#mdoperacoestabelas').on('shown.bs.modal', function (e) {                   
					$('#mdoperacoestabelas').focus();
                });

                $('#mdgerararquivo').on('shown.bs.modal', function (e) {                   
					// $('#cbtabelaarquivo').select2('open');
                    $('#cbtipoarquivo').focus();
                });
                $('#mdconsultaporcodigo').on('show.bs.modal', function(e){
                    vself.pcodigoconsultar        = '';
                    vself.lstprodutoconsultacodigo = [];
                });                
                $('#mdconsultaporcodigo').on('shown.bs.modal', function(e){
                    vself.pcodigoconsultar        = '';
                    vself.lstprodutoconsultacodigo = [];
                    $('#edcodigoconsultar').focus();
                });
                
                //classe do cálculo do imposto sobre o valor
                $('#mdimpostovalor').on('shown.bs.modal', function(e){
                    vself.ivalorbase = vself.vvltabela === 0 ? 0 : vself.vvltabela;
                    $('#edivalorbase').focus();
                });                                
                $("#cbiclasse").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbclassesimpostos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.iidclasse = $("#cbiclasse").val();
                    let loader      = vself.$loading.show();
                    let filtro      = ' and ci.id='+vself.iidclasse;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 99999999999},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                    retorno.then(function (response) {
                        loader.hide();                        
                        vself.iclasse        = response.data[0];
                        vself.iclasse.campos = vself.iclasse.lstcampos;
                        console.log(vself.iclasse);
                        vself.mtdcalculavalorimpostoclasse();

                    }).catch(function (response) {
                        vself.iclasse = [];
                        loader.hide();
                    });
                });
                
                //calcular preço médio para o custo
                $('#mdatribuirmargem').on('shown.bs.modal', function(e){
                    vself.amargem       = vself.vmargemprcusto;
                    vself.avalor        = vself.vprvendamedio;
                    $('#edamargem').focus();
                });
                
                //informar o valor para o cálculo do percentual do desconto promocional
                $('#mdinformarvalordescpromocional').on('shown.bs.modal', function(e){
                    vself.avalorsemdescpromocional = vself.vvltabela;
                    vself.avalorcomdescpromocional = vself.vvltabela - (parseFloat(vself.vvltabela) * parseFloat(vself.vvldescpromocional) / 100);
                    vself.mtdcalcularvalordescpromocional();
                    $('#edvalorcomdescpromocional').focus();
                });                
            },
            mtdmaisfiltros(){
                this.pdtini = util.DataAtual(true);
                this.pdtfim = util.DataAtual(true);
                this.pfiltrocadastropesq = 2;
                this.pfiltroncmpesq      = 2;
                if (this.pmaisfiltros === true){
                    this.pmaisfiltros = false;
                }else{
                    this.pmaisfiltros = true;
                }
            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                switch (parseInt(this.pfiltro)) {
                    case 0:
                        rfiltro = this.pconteudo === '' ? '' : ' and p.id='+this.pconteudo;
                    break;
                    case 1:
                        rfiltro = this.pconteudo === '' ? '' : ' and upper(p.descricao) like upper("'+this.pconteudo+'%")';
                    break;
                    case 2:
                        rfiltro = this.pconteudo === '' ? '' : ' and upper(p.referencia) like upper("'+this.pconteudo+'%")';
                    break;
                }
                if (parseInt(this.pstpro) < 2){
                    rfiltro = rfiltro + ' and p.stpro='+this.pstpro;
                }
                if (this.pidmarca !== null){
                    rfiltro = rfiltro + ' and p.idmarca='+this.pidmarca;
                }
                if (this.pidgrupo !== null){
                    rfiltro = rfiltro + ' and p.idgrupo='+this.pidgrupo;
                }
                if (this.pidsubgrupo !== null){
                    rfiltro = rfiltro + ' and p.idsubgrupo='+this.pidsubgrupo;
                }
                if (this.pidsetor !== null){
                    rfiltro = rfiltro + ' and p.idsetor='+this.pidsetor;
                }  
                if (this.pidncm !== null){
                    rfiltro = rfiltro + ' and p.idncm='+this.pidncm;
                }                              
                if (parseInt(this.pfracionado) < 2){
                    rfiltro = rfiltro + ' and p.fracionado='+this.pfracionado;
                }
                if (this.pespecificacao){
                    rfiltro = rfiltro + ' and upper(p.especificacao) like upper("'+this.pespecificacao+'%")';
                }
                
                if (this.pmaisfiltros){
                    if (parseInt(this.pfiltrocadastropesq) < 2){
                        if (parseInt(this.pfiltrocadastropesq) === 0){
                            rfiltro = rfiltro + ' and p.dtcadastro between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';               
                        }else{
                            rfiltro = rfiltro + ' and p.dtchange between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';                                           
                        }
                    }
                    if (parseInt(this.pfiltroncmpesq) < 2){
                        if (parseInt(this.pfiltroncmpesq) === 0){
                            rfiltro = rfiltro + ' and (p.idncm="" or p.idncm is null)';
                        }else{
                            rfiltro = rfiltro + ' and p.idncm<>""';
                        }
                    }

                }                

                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregaprodutos(1);
                }).catch(function (response) {
                    this.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdcarregaprodutos(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                vself.$refs.reflstprodutos.selected_items = [];//limpa os ítens selecionados na table 
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : 'listagem'},
                    {parametro: 'filtro',           valor : filtro},
                    {parametro: 'idestoque',        valor : vself.$store.state.filialpadrao.idestoque},
                    {parametro: 'limit',            valor : vself.pqtdregistros},
                    {parametro: 'offset',           valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                    {parametro: 'reserva',          valor : util.opcaousuario('002Z.002M.020M', vself.$store.state.perfilusuario) ? 1 : 0},
                    {parametro: 'estoquegeralconsultas', valor : vself.$store.state.usuario.estoquegeralconsultas},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    vself.lstprodutos = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstprodutos = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();
                this.vid                     = '';
                this.vdescricao              = '';
                this.vreferencia             = '';
                this.vstpro                  = 1;
                this.vdtcadastro             = '';
                this.vdtultimavenda          = null,
                this.vidultimavenda          = 0;
                this.vidmarca                = null;
                this.vidgrupo                = null;
                this.vidsubgrupo             = null;
                this.vidsetorproduto         = null;
                this.vund                    = null;
                this.vdiasvalidade           = 0;
                this.vreg                    = 0;
                this.vfracionado             = 0;
                this.vtipo                   = 0;
                this.vcontrolaserial         = 0;
                this.vestoqueminimo          = 0;
                this.vestoquemaximo          = 0;
                this.vespecificacao          = '';
                this.vprcompra               = 0;
                this.vpipi                   = 0;
                this.vpicms                  = 0;
                this.vpfrete                 = 0;
                this.vppis                   = 0;
                this.vpcofins                = 0;
                this.vpoutros                = 0;
                this.vbcst                   = 0;
                this.vcalculasubstributaria  = 0;
                this.vpst                    = 0;
                this.vvst                    = 0;
                this.vprcusto                = 0;
                this.vprvendamedio           = 0;
                this.vfatcomis               = 0;
                this.vcalcularprvendamedio   = false;
                this.vidncm                  = null;
                this.vidcest                 = null; 
                this.vcbsituacaotributaria   = null;  
                this.vtipoproduto            = 0;
                this.vorigemproduto          = 0;
                this.vprodutoespecifico      = 0;
                this.vpathimagens            = '';
                this.vobservacoes            = '';
                this.lstTabelasPrecos        = [];
                this.lstCodigos              = [];
                this.lstLocalizacaoProduto   = [];
                this.lstClassesProduto       = [];
                this.lstsimilaridades        = [];
                this.lstImagens              = [];

                //variáveis do cashback
                this.vvlcreditoacumulaavista = 0;
                this.vvlcreditoacumulaaprazo = 0;

                this.habdestab               = false;
                this.voptabela               = 1;


                this.vnovalocalizacao        = false;
                this.vdescricaolocalizacao   = '';
                this.vidnovalocalizacao      = '';                

                $('#cbunidade').val(null).trigger('change');
                $('#cbmarca').val(null).trigger('change');
                $('#cbgrupo').val(null).trigger('change');
                $('#cbsubgrupo').val(null).trigger('change');
                $('#cbtabelapreco').val(null).trigger('change');
                $('#cbfiliallocalizacao').val(null).trigger('change');
                $('#cbsetorproduto').val(null).trigger('change');
                $('#cbsetor').val(null).trigger('change');
                $('#cblocalizacao').val(null).trigger('change');
                $('#cbncm').val(null).trigger('change');
                $('#cbcest').val(null).trigger('change'); 
                $('#classe').val(null).trigger('change');
                $('#cbfilialclasse').val(null).trigger('change');                                
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                $('.nav-tabs a[href="#dvproduto"]').tab('show');
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) === 1) {
                        $('#eddescricao').focus();
                    }
                    else if (parseInt(this.opcrud) === 2){
                        $('#cbstpro').focus();
                    }
                    else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;                
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('002Z.002M.001M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO - PRODUTOS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                    this.vpathimagens = util.GerarStringAleatoria();
                }
            },
            mtdcancelaredicao(){
                $('.nav-tabs a[href="#dvproduto"]').tab('show');
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnimportacao').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstprodutos = [];
                this.$refs.reflstprodutos.selected_items = [];//limpa os ítens selecionados na table 
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (this.vdiasvalidade === ''){
                        vself.$toastr.w('Campo da validade do produto deve ser informado!', 'Atenção!');
                        $('#eddiasvalidade').focus();
                        return;
                    }                        
                    if (parseFloat(vself.vestoqueminimo) > 0){
                        if (parseFloat(vself.vestoquemaximo) === 0 ){
                            vself.$toastr.w('Ao definir estoque mínimo, você deve informar o estoque máximo!', 'Atenção!');
                            $('#edestoquemaximo').focus();
                            return;
                        }                        
                    }                    
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                setTimeout(function(){
                                    vself.mtdregistro();
                                },200);                                    
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and p.id='+id;
                let parametros  = [
                    {parametro: 'op',               valor : 'listagem'},
                    {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',           valor : filtro},
                    {parametro: 'limit',            valor : 1},
                    {parametro: 'offset',           valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    vself.$nextTick(function () {
                        if (parseInt(vself.opcrud) === 1) {
                            $('#eddescricao').focus();
                        }
                        else if (parseInt(vself.opcrud) === 2){
                            $('#cbstpro').focus();
                        }
                        else {
                            $('#btgravar').focus();
                        }
                    });
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('002Z.002M.002M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO - PRODUTOS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdclonar(item){
                let vself = this;
                if (!util.opcaousuario('002Z.002M.001M', this.$store.state.perfilusuario)){//mesmo código do perfil da inclusão do produto
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO - PRODUTOS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                    this.mtdlocalizaregistro(item.id);
                    setTimeout(() => {                            
                        vself.vpathimagens   = util.GerarStringAleatoria();
                        vself.vid            = '';
                        vself.lstCodigos     = [];                            
                        vself.lstImagens     = [];                         
                    }, 1000);                       
                }
            },            
            mtdexcluir(item){
                if (!util.opcaousuario('002Z.002M.003M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO - PRODUTOS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                    this.habdestab = true;
                }
            },
            mtdigualarcampos(registro){                
                this.vid                     = registro.id;
                this.vdescricao              = registro.descricao;
                this.vreferencia             = registro.referencia;
                this.vdtcadastro             = registro.dtcadastro;
                this.vdtultimavenda          = registro.dtultimavenda;
                this.vidultimavenda          = registro.idultimavenda;
                this.vund                    = registro.und;
                this.vdiasvalidade           = registro.diasvalidade;   
                this.vreg                    = registro.reg;
                this.vstpro                  = registro.stpro;
                this.vidmarca                = registro.idmarca;
                this.vidgrupo                = registro.idgrupo;
                this.vidsubgrupo             = registro.idsubgrupo;
                this.vidsetorproduto         = registro.idsetor;
                this.vfracionado             = registro.fracionado;
                this.vtipo                   = registro.tipo;
                this.vcontrolaserial         = registro.controlaserial;
                this.vestoqueminimo          = parseFloat(registro.estoqueminimo);
                this.vestoquemaximo          = parseFloat(registro.estoquemaximo);
                this.vespecificacao          = registro.especificacao;
                this.vprcompra               = parseFloat(registro.prcompra);
                this.vpipi                   = parseFloat(registro.pipi);
                this.vpicms                  = parseFloat(registro.picms);
                this.vpfrete                 = parseFloat(registro.pfrete);
                this.vppis                   = parseFloat(registro.ppis);
                this.vpcofins                = parseFloat(registro.pcofins);
                this.vpoutros                = parseFloat(registro.poutros);
                this.vbcst                   = parseFloat(registro.bcst);
                this.vcalculasubstributaria  = registro.calculasubstributaria;
                this.vpst                    = parseFloat(registro.pst);
                this.vvst                    = parseFloat(registro.vst);
                this.vprcusto                = parseFloat(registro.prcusto);
                this.vcalcularprvendamedio   = parseInt(registro.calcularprvendamedio) === 0 ? false : true;
                this.vprvendamedio           = parseFloat(registro.prvendamedio);
                this.vidncm                  = registro.idncm;
                this.vidcest                 = registro.idcest === '' ? null : registro.idcest;
                this.vidsituacaotributaria   = registro.idsituacaotributaria === '' ? null : registro.idsituacaotributaria;                
                this.vtipoproduto            = registro.tipoproduto;
                this.vorigemproduto          = registro.origemproduto;
                this.vprodutoespecifico      = registro.produtoespecifico;
                this.vpathimagens            = registro.pathimagens !== '' ? registro.pathimagens : util.GerarStringAleatoria();
                this.vobservacoes            = registro.observacoes;
                this.lstTabelasPrecos        = registro.tabelas;
                this.lstCodigos              = registro.codigos;
                this.lstLocalizacaoProduto   = registro.localizacoes;
                this.lstClassesProduto       = registro.classes;
                this.lstImagens              = registro.imagens;
                this.lstsimilaridades        = registro.similaridades;
                this.vfatcomis               = parseFloat(registro.fatcomissao);
                //variáveis do cashback
                this.vvlcreditoacumulaavista = parseFloat(registro.vlcreditoacumulaavista);
                this.vvlcreditoacumulaaprazo = parseFloat(registro.vlcreditoacumulaaprazo);

                var defunidade  = new Option(registro.descunidade, this.vund, true, true);
                $('#cbunidade').append(defunidade).trigger('change');

                var defmarca    = new Option(registro.descmarca, this.vidmarca, true, true);
                $('#cbmarca').append(defmarca).trigger('change');

                var defgrupo    = new Option(registro.descgrupo, this.vidgrupo, true, true);
                $('#cbgrupo').append(defgrupo).trigger('change');

                var defsubgrupo = new Option(registro.descsubgrupo, this.vidsubgrupo, true, true);
                $('#cbsubgrupo').append(defsubgrupo).trigger('change');

                var defsetor = new Option(registro.descsetor, this.vidsetorproduto, true, true);
                $('#cbsetorproduto').append(defsetor).trigger('change');                

                var defncm = new Option(registro.descncm, this.vidncm, true, true);
                $('#cbncm').append(defncm).trigger('change');                

                if (this.vidcest !== null){
                    var defcest = new Option(registro.desccest, this.vidcest, true, true);
                    $('#cbcest').append(defcest).trigger('change');                
                }else{
                    $('#cbcest').val(null).trigger('change'); 
                }

                if (this.vidsituacaotributaria !== null){
                    var defsituacaotributaria = new Option(registro.descsituacaotributaria, this.vidsituacaotributaria, true, true);
                    $('#cbsituacaotributaria').append(defsituacaotributaria).trigger('change');                
                }else{
                    $('#cbsituacaotributaria').val(null).trigger('change'); 
                }
                this.mtdcalculaprvendamedio();
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let semverificacoes = util.opcaousuario('002Z.002M.003N', this.$store.state.perfilusuario) ? 1 : 0;
                let registrocrud = {
                    'id'                    : this.vid,
                    'descricao'             : this.vdescricao,
                    'referencia'            : this.vreferencia,
                    'stpro'                 : this.vstpro,
                    'idmarca'               : this.vidmarca, 
                    'idgrupo'               : this.vidgrupo, 
                    'idsubgrupo'            : this.vidsubgrupo,
                    'idsetor'               : this.vidsetorproduto,
                    'und'                   : this.vund, 
                    'diasvalidade'          : this.vdiasvalidade,
                    'fracionado'            : this.vfracionado, 
                    'tipo'                  : this.vtipo, 
                    'controlaserial'        : this.vcontrolaserial, 
                    'estoqueminimo'         : this.vestoqueminimo, 
                    'estoquemaximo'         : this.vestoquemaximo, 
                    'especificacao'         : this.vespecificacao, 
                    'prcompra'              : this.vprcompra, 
                    'pipi'                  : this.vpipi, 
                    'picms'                 : this.vpicms, 
                    'pfrete'                : this.vpfrete, 
                    'ppis'                  : this.vppis, 
                    'pcofins'               : this.vpcofins, 
                    'poutros'               : this.vpoutros, 
                    'bcst'                  : this.vbcst, 
                    'calculasubstributaria' : this.vcalculasubstributaria, 
                    'pst'                   : this.vpst, 
                    'vst'                   : this.vvst, 
                    'prcusto'               : this.vprcusto, 
                    'calcularprvendamedio'  : this.vcalcularprvendamedio === false ? 0 : 1,
                    'prvendamedio'          : this.vprvendamedio,
                    'idncm'                 : this.vidncm, 
                    'idcest'                : this.vidcest === null ? '' : this.vidcest,
                    'idsituacaotributaria'  : this.vidsituacaotributaria === null ? '' : this.vidsituacaotributaria,
                    'tipoproduto'           : this.vtipoproduto, 
                    'origemproduto'         : this.vorigemproduto, 
                    'produtoespecifico'     : this.vprodutoespecifico,
                    'reg'                   : parseInt(this.vreg) === 0 ? 1 : 0,
                    'pathimagens'           : this.vpathimagens, 
                    'observacoes'           : this.vobservacoes,
                    'tabelasprecos'         : this.lstTabelasPrecos,
                    'codigos'               : this.lstCodigos,
                    'localizacoes'          : this.lstLocalizacaoProduto,
                    'classes'               : this.lstClassesProduto,
                    'similaridades'         : this.lstsimilaridades,
                    'fatcomissao'           : this.vfatcomis,
                    'vlcreditoacumulaavista': this.vvlcreditoacumulaavista,
                    'vlcreditoacumulaaprazo': this.vvlcreditoacumulaaprazo
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : 'rotinacrud'},
                    {parametro: 'opcrud',           valor : vself.opcrud},
                    {parametro: 'semverificacoes',  valor : semverificacoes},
                    {parametro: 'registro',         valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',            valor : parseInt(this.opcrud) === 1 ? '002Z.002M.001M' : parseInt(this.opcrud) === 2 ? '002Z.002M.002M' : '002Z.002M.003M'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.pmaisfiltros  = false;         
                        vself.mtdcancelaredicao();
                        vself.mtdcarregaprodutos(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdgravartabela(){ 
                if (parseInt(this.voptabela) === 1){//inclusão da tabela
                    if (this.vidtabelapreco === null) {
                        this.$toastr.w('Tabela de preço deve ser informada!', 'Atenção!');
                        $('#cbtabelapreco').select2('open');
                    }else if (this.vvltabela <= 0) {
                        this.$toastr.w('Preço de venda deve ser informado!', 'Atenção!');
                        $('#edvltabela').focus();
                    }else {
                        if (!util.findValInArray(this.lstTabelasPrecos, 'idtabela', this.vidtabelapreco)) {
                            let tabelapr = {
                                'idtabela'          : this.vidtabelapreco,
                                'desctabela'        : $('#cbtabelapreco').select2('data')[0]['text'],
                                'mrglucro'          : parseFloat(this.vmrgtabela),
                                'prtabela'          : parseFloat(this.vvltabela).toFixed(2),
                                'vlnf'              : parseFloat(this.vvlnf).toFixed(2),
                                'pcomissao'         : parseFloat(this.vcomissaotabela),
                                'qtdminima'         : parseFloat(this.vqtdmintabela),
                                'desconto'          : parseFloat(this.vdescontotabela),
                                'vlvisualiza'       : parseFloat(this.vvlvizu),
                                'vldescpromocional' : parseFloat(this.vvldescpromocional)
                            };                                          
                            this.lstTabelasPrecos.push(tabelapr);
                            this.vidtabelapreco  = null;
                            this.vmrgtabela      = 0;
                            this.vvltabela       = 0;
                            this.vvlnf           = 0;
                            this.vcomissaotabela = 0;
                            this.vqtdmintabela   = 0;
                            this.vdescontotabela = 0;
                            this.vvldescpromocional = 0;
                            this.vvlvizu         = 0;
                            this.voptabela       = 1;
                            this.habdestab       = false;
                            $('#cbtabelapreco').val(null).trigger('change');
                            this.mtdcalculaprvendamedio();
                            $('#cbtabelapreco').select2('open');
                        } else {
                            this.$toastr.w('Tabela de preço já cadastrada!', 'Atenção!');
                            $('#cbtabelapreco').select2('open');
                        }
                    }
                }else{//alteração da tabela
                    let indt = util.getArrayIndexForKey(this.lstTabelasPrecos, 'idtabela', this.vidtabelapreco);
                    
                    this.lstTabelasPrecos[indt].mrglucro          = parseFloat(this.vmrgtabela);
                    this.lstTabelasPrecos[indt].prtabela          = parseFloat(this.vvltabela).toFixed(2);
                    this.lstTabelasPrecos[indt].vlnf              = parseFloat(this.vvlnf).toFixed(2);
                    this.lstTabelasPrecos[indt].pcomissao         = parseFloat(this.vcomissaotabela);
                    this.lstTabelasPrecos[indt].qtdminima         = parseFloat(this.vqtdmintabela);
                    this.lstTabelasPrecos[indt].desconto          = parseFloat(this.vdescontotabela);
                    this.lstTabelasPrecos[indt].vlvisualiza       = parseFloat(this.vvlvizu);
                    this.lstTabelasPrecos[indt].vldescpromocional = parseFloat(this.vvldescpromocional);                    
                    this.vidtabelapreco  = null;
                    this.vmrgtabela      = 0;
                    this.vvltabela       = 0;
                    this.vvlnf           = 0;
                    this.vcomissaotabela = 0;
                    this.vqtdmintabela   = 0;
                    this.vdescontotabela = 0;
                    this.vvlvizu            = 0;
                    this.vvldescpromocional = 0;
                    this.voptabela       = 1;
                    this.habdestab       = false;
                    $('#cbtabelapreco').val(null).trigger('change');
                    this.mtdcalculaprvendamedio();
                    $('#cbtabelapreco').focus();                    
                }
            },
            mtdalterartabela(tabela){
                if (!this.ativadesativa) {   
                    this.voptabela  = 2;  
                    this.habdestab  = true;
                    var deftab      = new Option(tabela.desctabela, tabela.idtabela, true, true);
                    $('#cbtabelapreco').append(deftab).trigger('change');
                    this.vmrgtabela         = tabela.mrglucro;
                    this.vvltabela          = tabela.prtabela;
                    this.vvlvizu            = tabela.vlvisualiza;
                    this.vvlnf              = tabela.vlnf;
                    this.vcomissaotabela    = tabela.pcomissao;
                    this.vqtdmintabela      = tabela.qtdminima;
                    this.vdescontotabela    = tabela.desconto;
                    this.vvldescpromocional = tabela.vldescpromocional;
                    $('#edvltabela').focus();
                }
            },
            mtdcancelartabela(){
                this.voptabela          = 1; 
                this.habdestab          = false;
                this.vmrgtabela         = 0;
                this.vvltabela          = 0;
                this.vvlvizu            = 0;
                this.vvlnf              = 0;
                this.vcomissaotabela    = 0;
                this.vqtdmintabela      = 0;
                this.vdescontotabela    = 0;                
                this.vvldescpromocional = 0;
                $('#cbtabelapreco').val(null).trigger('change');
                $('#cbtabelapreco').select2('open');                  
            },
            mtddeletatabela(index) {
                if (!this.ativadesativa) {
                    this.lstTabelasPrecos.splice(index, 1);
                    this.mtdcalculaprvendamedio();
                    this.mtdcancelartabela();
                }
            },
            mtdcalculaprvendamedio(){
                if (!this.vcalcularprvendamedio){
                    if (this.lstTabelasPrecos.length > 0){
                        let vsoma = 0;
                        for (let i = 0; i < this.lstTabelasPrecos.length; i++) {
                            vsoma = vsoma + parseFloat(this.lstTabelasPrecos[i]['prtabela']);
                        }
                        if (parseFloat(vsoma) > 0){
                            this.vprvendamedio = vsoma / this.lstTabelasPrecos.length;
                        }else{
                            this.vprvendamedio = 0;
                        }
                    }else{
                        this.vprvendamedio = 0;
                    }
                }
                let difpr = this.vprvendamedio - this.vprcusto;
                if (parseFloat(this.vprcusto) > 0){
                    this.vmargemprcusto = (difpr / this.vprcusto * 100).toFixed(2);
                }else{
                    this.vmargemprcusto = 0;
                }
            },
            mtdinccodigo(){
                //Verifica se o código digitado não é igual ao principal
                if (this.vid !== '' ){
                    if (this.vcodigoinc === this.vid){
                        this.$toastr.w('Código não pode ser igual ao código principal!', 'Atenção!');
                        $("#edcodigoadd").focus();
                        return;
                    }
                }
                if (this.vcodigoinc === '') {
                    this.$toastr.w('Código deve ser informado!', 'Atenção!');
                    $("#edcodigoadd").focus();
                    return;
                }
                let codigotmp = {
                    'codigo'               : this.vcodigoinc,
                    'padraoetiqueta'       : 0 
                };
                if (!util.findValInArray(this.lstCodigos, 'codigo', codigotmp.codigo)){
                    this.lstCodigos.push(codigotmp);
                    this.vcodigoinc = '';
                    $('#edcodigoadd').focus();
                }else{
                    this.$toastr.w('Código já incluso para o produto!', 'Atenção!');
                    $('#edcodigoadd').focus();
                }
            },
            mtddelcodigo(index){
               this.lstCodigos.splice(index, 1); 
            },
            mtdincreferenciasimilar(){
                if (this.vreferenciasimilarinc === '') {
                    this.$toastr.w('Referência deve ser informado!', 'Atenção!');
                    $("#edreferenciasimilar").focus();
                    return;
                }
                let referenciatmp = {
                    'referencia'               : this.vreferenciasimilarinc.toUpperCase()
                };
                if (!util.findValInArray(this.lstsimilaridades, 'referencia', referenciatmp.referencia)){
                    this.lstsimilaridades.push(referenciatmp);
                    this.vreferenciasimilarinc = '';
                    $('#edreferenciasimilar').focus();
                }else{
                    this.$toastr.w('Referência já inclusa nas similaridades!', 'Atenção!');
                    $('#edreferenciasimilar').focus();
                }
            },
            mtddelreferenciasimilar(index){
               this.lstsimilaridades.splice(index, 1); 
            },            
            mtdinclocalizacao(){
                if (this.vidfiliallocalizacao == null) {
                    this.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    $("#cbfilialestoque").focus();
                    return;
                }
                if (this.vidlocalizacao == null) {
                    this.$toastr.w('Localização do estoque deve ser informada!', 'Atenção!');
                    $("#cblocalizacao").focus();
                    return;
                }
                let localizacaopro = {
                    'idfilial'             : this.vidfiliallocalizacao,
                    'fantasia'             : $('#cbfiliallocalizacao').select2('data')[0]['text'],
                    'idlocalizacao'        : this.vidlocalizacao,
                    'desclocalizacao'      : $('#cblocalizacao').select2('data')[0]['text']
                };
                if (!this.AchaLocalizacaoFil(this.lstLocalizacaoProduto, localizacaopro)){
                    this.lstLocalizacaoProduto.push(localizacaopro);

                    this.vdescricaolocalizacao   = '';
                    this.vidnovalocalizacao      = ''; 

                    this.vidfiliallocalizacao = null;
                    this.vidlocalizacao       = null;
                    $('#cbfiliallocalizacao').val(null).trigger('change');
                    $('#cblocalizacao').val(null).trigger('change');

                    $('#cbfiliallocalizacao').select2('open');

                }else{
                    this.$toastr.w('Já existe uma localização definida para a filial!', 'Atenção!');
                    $('#cbfiliallocalizacao').select2('open');
                }
            },
            mtddeletarlocalizacao(index){
                this.lstLocalizacaoProduto.splice(index, 1);
            },
            AchaLocalizacaoFil(arr, localizacao) {//verifica se existe um valor em uma chave de uma array
                if (arr){
                    for (var i = 0; i < arr.length; i++) {
                        //if (arr[i]['idfilial'] == localizacao.idfilial && arr[i]['idlocalizacao'] == localizacao.idlocalizacao) return true;
                        if (arr[i]['idfilial'] == localizacao.idfilial) return true;
                    }
                }
                return false;
            },
            mtdincluirclasse(){
                if (this.vidclasse == null) {
                    this.$toastr.w('Classe deve ser informada!', 'Atenção!');
                    $("#cbclasse").focus();
                    return;
                }
                if (this.vidfilialclasse == null) {
                    this.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    $("#cbfilialclasse").focus();
                    return false;
                }
                let classeproduto = {
                    'idclasse'     : this.vidclasse,
                    'descclasse'   : $('#cbclasse').select2('data')[0]['text'],
                    'idfilial'     : this.vidfilialclasse,
                    'fantasia'     : $('#cbfilialclasse').select2('data')[0]['text']
                }
                if (!this.AchaClasseFil(this.lstClassesProduto, classeproduto.idclasse, classeproduto.idfilial)){
                    this.lstClassesProduto.push(classeproduto);
                    this.vidclasse       = null;
                    this.vidfilialclasse = null;
                    $('#cbclasse').val(null).trigger('change');
                    $('#cbfilialclasse').val(null).trigger('change');
                    $('#cbclasse').focus();
                }else{
                    this.$toastr.w('Classe já inclusa para a filial!', 'Atenção!');
                    $('#cbclasse').focus();
                }                
            },
            mtdexcluirclasse(index){
                this.lstClassesProduto.splice(index, 1);
            },
            AchaClasseFil(arr, idclasse, idfilial) {
                if (arr){
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i]['idclasse'] == idclasse && arr[i]['idfilial'] == idfilial) return true;
                    }
                }
                return false;
            },
            mtdcalculaprtabela(){
                if (parseFloat(this.vprcusto) > 0){                
                    let vladd       = parseFloat(this.vmrgtabela) * parseFloat(this.vprcusto)  / 100;
                    this.vvltabela  = parseFloat(this.vprcusto) + vladd;                
                }else{
                    this.vvltabela  = 0;
                }
            },
            mtdcalculamrgtabela(){
                let dif = this.vvltabela - this.vprcusto;
                if (dif > 0){                    
                    if(this.vprcusto > 0){
                        let mrg = dif / this.vprcusto * 100;
                        this.vmrgtabela = mrg;
                    }else{
                        this.vmrgtabela = 0;
                    }
                }else{
                    this.vmrgtabela = 0;
                }                
            },
            mtdrecalcularmargemtabelas(){
                if (this.lstTabelasPrecos.length > 0){
                    let lstcalc             = this.lstTabelasPrecos;
                    this.lstTabelasPrecos   = [];                    
                    if (lstcalc) {
                        for (var i = 0; i < lstcalc.length; i++) {
                            let dif = lstcalc[i]['prtabela'] - this.vprcusto;
                            if (dif > 0){
                                if(this.vprcusto > 0){
                                    let mrg = dif / this.vprcusto * 100;
                                    lstcalc[i]['mrglucro'] = parseFloat(mrg.toFixed(2));
                                }else{
                                    lstcalc[i]['mrglucro']     = 0;
                                }
                            }else{
                                lstcalc[i]['mrglucro']     = 0;
                            }
                        }
                    }                    
                    this.lstTabelasPrecos   = lstcalc;                    
                }
            },
            mtdajustarestoque(item){
                if (!util.opcaousuario('002Z.002M.004M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.vidproduto          = item.id;
                    this.vdescpro            = item.descricao;
                    this.vunidadepro         = item.und;
                    this.vqtdmov             = 1;
                    this.vvlmov              = item.prcusto;
                    this.vdtmov              = util.DataAtual(true);
                    this.vtpmov              = 0;
                    this.vperda              = 0;
                    this.vobsmov             = '';
                    this.vqtdanterior        = 0;
                    this.vundanterior        = item.und;
                    this.vprofracionado      = item.fracionado;

                    let defestoque           = new Option(this.$store.state.filialpadrao.descestoque, this.$store.state.filialpadrao.idestoque, true, true);
                    $('#cbestoque').append(defestoque).trigger('change');
                    
                    var deffil                = new Option(this.$store.state.filialpadrao.descfil, this.$store.state.filialpadrao.codfil, true, true);
                    $('#cbfilialajuste').append(deffil).trigger('change');                       

                    $('#mdajuste').modal('show');
                }
            },
            mtdconfirmarajuste() {
                if (this.videstoque === null || this.videstoque === undefined || this.videstoque === '') {
                    this.$toastr.w('Estoque do produto deve ser informado!', 'Atenção!');
                    return;
                }
                if (this.vdtmov === null || this.vdtmov === undefined || this.vdtmov === '') {
                    this.$toastr.w('Data do movimento deve ser informada!', 'Atenção!');
                    return;
                }
                if (this.vidfilialajuste === null || this.vidfilialajuste === undefined || this.vidfilialajuste === '') {
                    this.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    return;
                }
                if (this.vqtdmov <= 0){
                    this.$toastr.w('Quantidade do movimento inválida!', 'Atenção!');
                    return;                    
                }
                if (parseInt(this.vprofracionado) === 0){
                    if (!Number.isInteger(util.formatarvalorDB(this.vqtdmov))){
                        this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
                        return;
                    }
                }                
                
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                if(parseInt(vself.vtpmov) === 0){
                    vself.msgTitAjuste   = 'ENTRADA'
                }else{
                    vself.msgTitAjuste   = 'SAÍDA';
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a '+ vself.msgTitAjuste + ' do estoque?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: true,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                setTimeout(function(){
                                    vself.mtdregistroajuste();
                                },200);                                    
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btconfirmar').focus();
                            }
                        }
                    }
                });             
            },
            mtdregistroajuste(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registroajuste = {
                    'idfilial'           : this.vidfilialajuste, 
                    'idproduto'          : this.vidproduto,
                    'idestoque'          : this.videstoque,
                    'qtdmov'             : this.vqtdmov,
                    'und'                : this.vunidadepro,                    
                    'vlmov'              : this.vvlmov,
                    'dtmov'              : this.vdtmov,
                    'tpmov'              : this.vtpmov, 
                    'perda'              : this.vperda,
                    'obsmov'             : this.vobsmov,
                    'idorigem'           : this.vtpmov,
                    'idusuario'          : this.$store.state.usuario.id,
                    'qtdestoque'         : this.vqtdanterior,
                    'docmov'             : this.vdocmov                    
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : 'rotinaajuste'},
                    {parametro: 'registro',         valor : JSON.stringify(registroajuste)},
                    {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',            valor : '002Z.002M.004M'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Ajuste realizado com sucesso!', 'Informação!');

                        setTimeout(function (){
                            if (vself.videstoque != null) {
                                let loader      = vself.$loading.show();
                                let parametros  = [
                                    {parametro: 'op',           valor : 'buscarestoque'},
                                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'filtro',       valor : ' and idproduto='+vself.vidproduto+ ' and idestoque='+vself.videstoque},
                                    {parametro: 'limit',        valor : 1},
                                    {parametro: 'offset',       valor : 0},
                                ];
                                let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                                retorno.then(function (response) {
                                    vself.vqtdatualizada = parseFloat(response.data[0].quantidade);
                                    vself.$toastr.i('Estoque atualizado ' +vself.vqtdatualizada, 'Informação!');
                                    loader.hide();
                                }).catch(function (response) {
                                    console.log(response);
                                    loader.hide();
                                });
                            } else {
                                vself.vqtdatualizada = 0;
                            }                             
                        }, 200);
                        
                        $('#mdajuste').modal('hide');
                    }else{
                        let tpret = response.data.substring(0,1);

                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o ajuste. Descrição do erro: '+response.message, 'Erro!');
                }); 
            },
            mtdrotinaclasses(){
                if (!util.opcaousuario('002Z.002M.005M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                
                    if (this.$refs.reflstprodutos.selected_items.length === 0){
                        this.$toastr.w('Selecione os produtos para a atribuição da classe!', 'Atenção!');
                        return;
                    }
                    this.vopcaoclasseatribuir  = 0; 
                    this.vatribuitodosprodutos = false;
                    $('#cbclasseatribuir').val(null).trigger('change');
                    $('#cbfilialatribuir').val(null).trigger('change');                                
                    $('#mdatribuirclasse').modal('show');
                }        
            },
            mtdatribuirclasse(){
                let vself = this;
				if (this.vidfilialatribuir === null){
					this.$toastr.w('Filial deve ser informada!', 'Atenção!');
					$('#cbfilialatribuir').focus();
					return;
                }
				if (this.vidclasseatribuir === null){
					this.$toastr.w('Classe deve ser informada!', 'Atenção!');
					$('#cbclasseatribuir').focus();
					return;
				}                
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a atribuição da classe para os produtos selecionados?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: true,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                this.buttons.sim.disable();
                                setTimeout(function(){                                    
                                    let lstprodutosatribuir = [];
                                    for (let produto of vself.$refs.reflstprodutos.selected_items) {
                                        lstprodutosatribuir.push(produto.id);
                                    }
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',               valor : 'atribuirclasse'},
                                        {parametro: 'opcaoclasse',      valor : vself.vopcaoclasseatribuir},                                        
                                        {parametro: 'produtos',         valor : JSON.stringify(lstprodutosatribuir)},
                                        {parametro: 'idclasseatribuir', valor : vself.vidclasseatribuir},
                                        {parametro: 'idfilialatribuir', valor : vself.vidfilialatribuir},
                                        {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                                        {parametro: 'todosprodutos',    valor : vself.vatribuitodosprodutos === false ? 0 : 1},
                                        {parametro: 'codop',            valor : '002Z.002M.005M'},
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            $('#mdatribuirclasse').modal('hide');
                                            vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                                            vself.pqtd_paginas  = 1;
                                            vself.mtdcancelaredicao();
                                            vself.mtdcarregaprodutos(1);
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });                                    
                                },200);                                    
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btconfirmar').focus();
                            }
                        }
                    }
                });
            },
            mtdrotinacampos(){
                if (!util.opcaousuario('002Z.002M.010M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                
                    if (this.$refs.reflstprodutos.selected_items.length === 0){
                        this.$toastr.w('Selecione os produtos para a atribuição dos campos!', 'Atenção!');
                        return;
                    }
                    this.valcomis            = 0;
                    this.vatribuircomis      = false
                    this.vreferenciacampos   = '';
                    this.vfracionadocampos   = 1;
                    this.vsituacaocampos     = 1;
                    this.vatribuirsituacao   = false;                        
                    this.vatribuirreferencia = false;
                    this.vatribuirfracionado = false;
                    this.vatribuiridunidade  = false;
                    this.vatribuiridmarca    = false;
                    this.vatribuiridgrupo    = false;
                    this.vatribuiridsubgrupo = false;
                    this.vatribuiridncm      = false;
                    this.vatribuiridcest     = false;
                    this.vatribuirlocalizacao= false; 
                    this.vatribuirsetor      = false;                       
                    $('#cbunidadecampos').val(null).trigger('change');
                    $('#cbmarcacampos').val(null).trigger('change');
                    $('#cbgrupocampos').val(null).trigger('change');
                    $('#cbsubgrupocampos').val(null).trigger('change');
                    $('#cbncmcampos').val(null).trigger('change');
                    $('#cbcestcampos').val(null).trigger('change');                               
                    $('#cbfilialatribuirloc').val(null).trigger('change');                               
                    $('#cbsetorprodutoatribuir').val(null).trigger('change');                                                       
                    $('#mdatribuircampos').modal('show');
                }                 
            },
            mtdatribuircampos(){
                let vself = this;                
                if (!this.vatribuirreferencia && !this.vatribuirfracionado &&
                    !this.vatribuiridunidade && !this.vatribuiridmarca && !this.vatribuiridgrupo && 
                    !this.vatribuiridsubgrupo && !this.vatribuiridncm && !this.vatribuiridcest && 
                    !this.vatribuirlocalizacao && !this.vatribuirsituacao && !this.vatribuirsetor && !this.vatribuircomis){
					this.$toastr.w('Selecione ao menos um campo para a atribuição!', 'Atenção!');
					return;
                }
				if (this.vatribuiridunidade === true && this.vidunidadecampos === null){
					this.$toastr.w('Campo "Unidade" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbunidadecampos').focus();
					return;
                }
				if (this.vatribuiridmarca === true && this.vidmarcacampos === null){
					this.$toastr.w('Campo "Marca" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbmarcacampos').focus();
					return;
                }
				if (this.vatribuiridgrupo === true && this.vidgrupocampos === null){
					this.$toastr.w('Campo "Grupo" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbgrupocampos').focus();
					return;
                }
				if (this.vatribuiridsubgrupo === true && this.vidsubgrupocampos === null){
					this.$toastr.w('Campo "Subgrupo" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbsubgrupocampos').focus();
					return;
                }
				if (this.vatribuiridncm === true && this.vidncmcampos === null){
					this.$toastr.w('Campo "NCM" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbncmcampos').focus();
					return;
                }
				if (this.vatribuiridcest === true && this.vidcestcampos === null){
					this.$toastr.w('Campo "CEST" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbcestcampos').focus();
					return;
                }

				if (this.vatribuirlocalizacao === true){
                    if (this.vidfilialatribuirloc === null){
                        this.$toastr.w('Campo "Localização" foi selecionado, portanto, a filial deve ser informada!', 'Atenção!');
                        $('#cbfilialatribuirloc').select2('open');
                        return;
                    }
                    if (this.vidlocalizacaoatribuir === null){
                        this.$toastr.w('Campo "Localização" foi selecionado, portanto, deve ser informado!', 'Atenção!');
                        $('#cblocalizacaoatribuir').select2('open');
                        return;
                    }
                }

                let stratribuir = "";
   
                if (this.vatribuirsituacao){
                    stratribuir = 'stpro='+this.vsituacaocampos+', ';
                }
                if (this.vatribuirreferencia){
                    stratribuir = stratribuir + 'referencia="'+this.vreferenciacampos+'", ';
                }
                if (this.vatribuirfracionado){
                    stratribuir = stratribuir + 'fracionado='+this.vfracionadocampos+', ';
                }
                if (this.vatribuiridunidade){
                    stratribuir = stratribuir + 'und="'+this.vidunidadecampos+'", ';
                }
                if (this.vatribuiridmarca){
                    stratribuir = stratribuir + 'idmarca='+this.vidmarcacampos+', ';
                }
                if (this.vatribuiridgrupo){
                    stratribuir = stratribuir + 'idgrupo='+this.vidgrupocampos+', ';
                }
                if (this.vatribuiridsubgrupo){
                    stratribuir = stratribuir + 'idsubgrupo='+this.vidsubgrupocampos+', ';
                }
                if (this.vatribuirsetor){
                    stratribuir = stratribuir + 'idsetor='+this.vidsetorprodutoatribuir+', ';
                }                
                if (this.vatribuiridncm){
                    stratribuir = stratribuir + 'idncm="'+this.vidncmcampos+'", ';
                }
                if (this.vatribuiridcest){
                    stratribuir = stratribuir + 'idcest="'+this.vidcestcampos+'", ';
                } 
                if (this.vatribuircomis){
                    stratribuir = stratribuir + 'fatcomissao='+this.valcomis+', ';
                }                               
                if (stratribuir !== ""){
                    stratribuir = stratribuir.substring(0, stratribuir.length - 2);//remove a ", " do final da string
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a atribuição dos campos aos produtos selecionados?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: true,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                this.buttons.sim.disable();
                                setTimeout(function(){                                    
                                    let lstprodutosatribuir = '';
                                    for (let produto of vself.$refs.reflstprodutos.selected_items) {
                                        lstprodutosatribuir = lstprodutosatribuir + produto.id + ', ';
                                    }
                                    lstprodutosatribuir = lstprodutosatribuir.substring(0, lstprodutosatribuir.length - 2);//remove a ", " do final da string
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',               valor : 'atribuircampos'},
                                        {parametro: 'stratribuir',      valor : stratribuir},
                                        {parametro: 'atribuirloc',      valor : vself.vatribuirlocalizacao ? 1 : 0},
                                        {parametro: 'idfilialloc',      valor : vself.vidfilialatribuirloc},
                                        {parametro: 'idlocalizacao',    valor : vself.vidlocalizacaoatribuir},                                        
                                        {parametro: 'produtos',         valor : lstprodutosatribuir},
                                        {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',            valor : '002Z.002M.010M'},
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            $('#mdatribuircampos').modal('hide');
                                            vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                                            vself.pqtd_paginas  = 1;
                                            vself.mtdcancelaredicao();
                                            vself.mtdcarregaprodutos(1);
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });                                    
                                },200);                                    
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btconfirmar').focus();
                            }
                        }
                    }
                });
            },
            mtdrotinatabela(){
                // if (!util.opcaousuario('002Z.002M.005M', this.$store.state.perfilusuario)){
                //     this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                // }else {                
                    if (this.$refs.reflstprodutos.selected_items.length === 0){
                        this.$toastr.w('Selecione os produtos para a atribuição da tabela!', 'Atenção!');
                        return;
                    }
                    this.vidtabelaatribuir               = null;
                    this.vmrgtabelaatribuir              = 0;
                    this.vprecoatribuir                  = 0;
                    this.vtipoatribuirtabela             = 0;
                    this.vcomissaotabelaatribuir         = 0;
                    this.vqtdmintabelaatribuir           = 0;
                    this.vdescontotabelaatribuir         = 0;
                    $('#cbtabelaatribuir').val(null).trigger('change');
                    $('#mdatribuirtabela').modal('show');
                //}      
            },
            mtdatribuirtabela(){
                let vself = this;
				if (this.vidtabelaatribuir === null){
					this.$toastr.w('Tabela de preço deve ser informada!', 'Atenção!');
					$('#cbtabelatribuir').select2('open');
					return;
                }
                if (parseInt(vself.vtipoatribuirtabela) === 1){
                    if (this.vprecoatribuir <= 0){
                        this.$toastr.w('O preço a ser atribuído deve ser informada!', 'Atenção!');
                        $('#edprecoatribuir').select2('open');
                        return;
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a atribuição da tabela de preços para os produtos selecionados?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: true,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                this.buttons.sim.disable();
                                setTimeout(function(){                                    
                                    let lstprodutosatribuir = [];
                                    for (let produto of vself.$refs.reflstprodutos.selected_items) {
                                        lstprodutosatribuir.push(produto.id);
                                    }
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',               valor : 'atribuirtabela'},
                                        {parametro: 'tipoabribuicao',   valor : vself.vtipoatribuirtabela},
                                        {parametro: 'produtos',         valor : JSON.stringify(lstprodutosatribuir)},
                                        {parametro: 'idtabela', 		valor : vself.vidtabelaatribuir},
                                        {parametro: 'mrglucro', 		valor : vself.vmrgtabelaatribuir},
                                        {parametro: 'preco',            valor : vself.vprecoatribuir},    
                                        {parametro: 'pcomissao', 		valor : vself.vcomissaotabelaatribuir},
                                        {parametro: 'qtdminima', 		valor : vself.vqtdmintabelaatribuir},
                                        {parametro: 'desconto', 		valor : vself.vdescontotabelaatribuir},                                        
                                        {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',            valor : '002Z.002M.005M'},
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            $('#mdatribuirtabela').modal('hide');
                                            vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                                            vself.pqtd_paginas  = 1;
                                            vself.mtdcancelaredicao();
                                            vself.mtdcarregaprodutos(1);
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });                                    
                                },200);                                    
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });
            },               
            mtdvisualizarestoque(produto){
                this.idprodutoestoque   = produto.id;
                this.descproestoque     = produto.descricao;
                $('#mdestoqueproduto').modal('show');
            },
            mtdvisualizarfornecedores(produto){
                this.idprodutofornecedores   = produto.id;
                this.descprofornecedores     = produto.descricao;
                $('#mdfornecedores').modal('show');
            },            
            mtdrotinaimportacao(){
                if (!util.opcaousuario('002Z.002M.015M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'CENTRAL DE IMPORTAÇÃO DE PRODUTOS';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    $('#pnlista').hide();
                    this.resetarDados();
                    this.arqselecionado     = null;
                    this.vlimpardados       = false;
                    this.vimportarcodigos   = false;
                    this.vreconstruirchaves = false;
                    $('#pnimportacao').fadeIn(700);
                }                
            },
            mtdbaixarmatriz(){
                window.open('https://www.rillsoft-app.cloud/controller/arquivosimportacao/manager/matrizes/matrizimportarprodutos.xls', '_blank');
            },
            mtdselecionararquivo(event){                
                let vself            = this;                 
                vself.arqselecionado = event.target.files[0];

                let extarq  = vself.arqselecionado.name.substring(vself.arqselecionado.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XLS'){
                    vself.arqselecionado = null;
                    vself.$toastr.w('O arquivo selecionado não possui um formato válido', 'Atenção!');
                    return;
                }

                let loader      = vself.$loading.show();
                let localsalvar = 'controller/arquivosimportacao/manager/'+
                                  vself.$store.state.filialpadrao.idcliente;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.mtdcancelaredicao();
                        vself.lstprodutos= [];
                        vself.pqtd_paginas   = 0;                                                
                        let oplimpar         = vself.vlimpardados === false ? '0' : '1';
                        let opcodigos        = vself.vimportarcodigos === false ? '0' : '1';
                        let opreconstruir    = vself.vreconstruirchaves === false ? '0' : '1';
                        let url              = 'https://www.'+vself.$store.state.usuario.adrsrv+'/controller/importadores/manager/importarprodutos.php?idclientesac='+vself.$store.state.filialpadrao.idcliente+
                                               '&arquivoimportar='+vself.arqselecionado.name+'&limparcadastro='+oplimpar+
                                               '&idfilial='+vself.$store.state.filialpadrao.codfil+'&idu='+
                                               vself.$store.state.usuario.id+'&importarcodigos='+opcodigos+'&codop=002Z.002M.015M'+
                                               '&reconstruirchaves='+opreconstruir;
                        vself.arqselecionado = null;                                               
                        window.open(url, '_blank');                        
                    }else{
                        vself.arqselecionado = null;
                        $('#ipselecionararquivo').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.arqselecionado = null;
                    $('#ipselecionararquivo').val('');
                });                
            },
            mtdbaixaretiquetador(){
                window.open('https://www.rillsoft-app.cloud/arquivos/manager/programas/instaladorlabelcreator.exe', '_blank');                
            },
            mtdrotinaarquivo(){
                // if (!util.opcaousuario('002Z.002M.005M', this.$store.state.perfilusuario)){
                //     this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                // }else {                
                    // if (this.$refs.reflstprodutos.selected_items.length === 0){
                    //     this.$toastr.w('Selecione os produtos para geração do arquivo!', 'Atenção!');
                    //     return;
                    // }                    
                    this.vtipoarquivo       = 0;
                    this.vidfilialarquivo   = null;
                    this.vidncmarquivo      = null;
                    this.vidclassearquivo   = null;
                    this.videstoquearquivo  = null;
                    this.vidtabelaarquivo   = null;
                    this.vidmarcaarquivo    = null,
                    this.vidgrupoarquivo    = null,
                    this.vidsubgrupoarquivo = null,
                    this.vidsetorarquivo    = null,
                    this.vstproarquivo      = 1; 
                    this.vfracionadoarquivo = 2;            
                    this.vlayoutbalanca     = 1;
                    this.vestoquearquivo    = 2;
                    this.lstprodutosexportar= [];
                    $('#cbfilialarquivo').val(null).trigger('change');
                    $('#cbncmarquivo').val(null).trigger('change');
                    $('#cbclassearquivo').val(null).trigger('change');
                    $('#cbestoquearquivo').val(null).trigger('change');                    
                    $('#cbtabelaarquivo').val(null).trigger('change');
                    $('#cbmarcaarquivo').val(null).trigger('change');
                    $('#cbgrupoarquivo').val(null).trigger('change');
                    $('#cbsubgrupoarquivo').val(null).trigger('change');
                    $('#cbsetorarquivo').val(null).trigger('change');
                    $('#mdgerararquivo').modal('show');
                //}               
            },
            mtdgerararquivo(){
                let vself = this;

                if (parseInt(vself.vtipoarquivo) === 2){
                    if (parseInt(vself.vestoquearquivo) < 2 && vself.videstoquearquivo === null){
                        vself.$toastr.w('Estoque deve ser informado!', 'Atenção!');
                        $('cbestoquearquivo').select2('open');
                        return;
                    }
                }
                if (parseInt(vself.vtipoarquivo) < 2){
                    if (vself.vidtabelaarquivo === null){
                        vself.$toastr.w('Tabela de preços deve ser informada!', 'Atenção!');
                        $('cbtabelaarquivo').select2('open');
                        return;
                    }
                }else{
                    if (vself.vidfilialarquivo === null){
                        vself.$toastr.w('Filial deve ser informada!', 'Atenção!');
                        $('cbfilialarquivo').select2('open');
                        return;
                    }                    
                }
                let rfiltro = '';
                if (parseInt(this.vstproarquivo) < 2){
                    rfiltro = rfiltro + ' and p.stpro='+this.vstproarquivo;
                }
                if (this.vidmarcaarquivo !== null){
                    rfiltro = rfiltro + ' and p.idmarca='+this.vidmarcaarquivo;
                }
                if (this.vidgrupoarquivo !== null){
                    rfiltro = rfiltro + ' and p.idgrupo='+this.vidgrupoarquivo;
                }
                if (this.vidsubgrupoarquivo !== null){
                    rfiltro = rfiltro + ' and p.idsubgrupo='+this.vidsubgrupoarquivo;
                }
                if (this.vidsetorarquivo !== null){
                    rfiltro = rfiltro + ' and p.idsetor='+this.vidsetorarquivo;
                }                
                if (parseInt(this.vfracionadoarquivo) < 2){
                    rfiltro = rfiltro + ' and p.fracionado='+this.vfracionadoarquivo;
                }
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : parseInt(vself.vtipoarquivo) < 2 ? 'arquivoprodutos' : 'listagemexportacao'},
                    {parametro: 'tipoarquivo',      valor : vself.vtipoarquivo},                    
                    {parametro: 'filtro',           valor : rfiltro},
                    {parametro: 'idfilial', 		valor : vself.vidfilialarquivo},
                    {parametro: 'idclasse', 		valor : vself.vidclassearquivo  === null ? 0 : vself.vidclassearquivo},
                    {parametro: 'idestoque', 		valor : vself.videstoquearquivo === null ? 0 : vself.videstoquearquivo},
                    {parametro: 'estoque', 		    valor : vself.vestoquearquivo},
                    {parametro: 'idtabela', 		valor : vself.vidtabelaarquivo},
                    {parametro: 'layoutbalanca',    valor : vself.vlayoutbalanca},
                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    loader.hide();
                    if (parseInt(vself.vtipoarquivo) < 2){
                        let vconteudoarquivo = response.data;
                        if (parseInt(vself.vtipoarquivo) === 0){
                            if (parseInt(vself.vlayoutbalanca) === 0){
                                util.download(vconteudoarquivo, 'CADTXT.TXT');
                            }else{
                                util.download(vconteudoarquivo, 'TXITENS.TXT');
                            }
                        }else{
                            util.download(vconteudoarquivo, 'PRICETAB.TXT');
                        }
                    }else{
                        vself.lstprodutosexportar = response.data;
                        console.log(vself.lstprodutosexportar);
                        setTimeout(() => {
                            vself.mtdexportarexcel();
                        }, 500);                        
                    }
                    $('#mdgerararquivo').modal('hide');
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar a solicitação. Descrição do erro: '+response.message, 'Erro!');
                });                                          
            },
            mtdrotinaconsultaprodutoscodigo(){
                $('#mdconsultaporcodigo').modal('show');
            },
            mtdlistarprodutosporcodigo(){
                var vself           = this;                
                if (vself.pcodigoconsultar.trim() !== ''){
                    $("#myInputID").blur(); 
                    let loader      = vself.$loading.show();
                    let parametros      = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor  : 'consultarcodigo'},
                        {parametro: 'codigo',       valor  : vself.pcodigoconsultar}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.lstprodutoconsultacodigo = response.data;

                        if(vself.lstprodutoconsultacodigo.length === 0){
                            $.confirm({
                                title: 'Confirmação!',
                                content: 'O código <strong>'+vself.pcodigoconsultar+'</strong> não foi encontrado. deseja cadastrar?',
                                icon: 'fa fa-question-circle',
                                escapeKey: true,
                                backgroundDismiss: false,
                                escapeKey: 'nao',
                                type: 'dark',
                                typeAnimated: true,
                                buttons: {
                                    sim: {
                                        text: '<u>S</u>im',
                                        keys: ['s', 'S'],
                                        btnClass: 'btn-blue',
                                        action: function () {                                
                                            setTimeout(function(){
                                                vself.mtdprocessanovocomcodigo();
                                            },200);                                    
                                        },
                                    },
                                    nao: {
                                        text: '<u>N</u>ão',
                                        keys: ['n', 'N'],
                                        action: function () {
                                        }
                                    }
                                }
                            });
                        }
                    }).catch(function (response) {
                        this.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                        loader.hide();
                    });                
                }
            },
            mtdrotinaoperacoestabelas(){
                if (!util.opcaousuario('002Z.002M.012M', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else { 
                    this.otpoperacao             = 0;                        
                    this.oidtabelaorigem         = null;
                    this.oidtabelaatribuirop     = null;
                    this.omrgtabelaatribuirop    = 0;
                    this.oidmarcaatribuirop      = null;
                    this.oidgrupoatribuirop      = null;
                    this.oidsubgrupoatribuirop   = null;                        
                    this.oidsetoratribuirop      = null;
                    this.ofatortabelaajuste      = 0;
                    this.otpfatorajuste          = 0;
                        
                    $('#cbtabelaorigem').val(null).trigger('change');                                         
                    $('#cbtabelaatribuirop').val(null).trigger('change');                                     
                    $('#cbmarcaatribuirop').val(null).trigger('change');                                         
                    $('#cbgrupoatribuirop').val(null).trigger('change');                                                                 
                    $('#cbsubgrupoatribuirop').val(null).trigger('change');                                                                 
                    $('#cbsetoratribuirop').val(null).trigger('change');
                                            
                    $('#mdoperacoestabelas').modal('show');

                }    
            },
            mtdconfirmaroperacaotabelas(){
                let vself = this;
                if (parseInt(vself.otpoperacao) === 0){
                    if (vself.oidtabelaorigem === null){
                        vself.$toastr.w('Tabela de origem deve ser informada!', 'Atenção!');
                        $('#cbtabelaorigem').select2('open');
                        return;
                    }
                }
                if (parseInt(vself.otpoperacao) === 0){
                    if (vself.oidtabelaatribuirop === null){
                        vself.$toastr.w('Tabela à abribuir deve ser informada!', 'Atenção!');
                        $('#cbtabelaatribuirop').select2('open');
                        return;
                    }
                    //Nilson 25/01/2023 - Comentei pois pode ser usado para criar tabela de promoção
                    //e o valor de alguns itens podem ser o mesmo de uma tabela convencional
                    // if (vself.omrgtabelaatribuirop === 0){
                    //     vself.$toastr.w('Informe o percentual da margem!', 'Atenção!');
                    //     $('#edmargematribuirop').focus();
                    //     return;
                    // } 
                    if (vself.oidtabelaorigem === vself.oidtabelaatribuirop){
                        vself.$toastr.w('Tabelas não podem ser as mesmas!', 'Atenção!');
                        $('#cbtabelaatribuirop').select2('open');
                        return;
                    }                                       
                }
                if (parseInt(vself.otpoperacao) === 3){    
                    if (vself.oidtabelaorigem === null){
                        vself.$toastr.w('Tabela de origem deve ser informada!', 'Atenção!');
                        $('#cbtabelaorigem').select2('open');
                        return;
                    }
                    if (vself.ofatortabelaajuste === 0){
                        vself.$toastr.w('Fator de ajuste deve ser informado!', 'Atenção!');
                        $('#edfatoratribuirop').focus();
                        return;
                    }                                                     
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma "'+$('#cbtpoperacao :selected').text()+'"?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {                                
                                $('.btn-blue').prop('disabled', true);
                                $('#mdoperacoestabelas').modal('hide');
                                setTimeout(function(){
                                    vself.mtdatribuiroperacaotabelas();
                                },200);                                    
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });                
            },
            mtdatribuiroperacaotabelas(){
                let vself           = this;
                let filtroprodutos  = "";

                if (vself.oidmarcaatribuirop !== null){
                    filtroprodutos = " and p.idmarca="+vself.oidmarcaatribuirop;
                }

                if (vself.oidgrupoatribuirop !== null){
                    filtroprodutos = filtroprodutos + " and p.idgrupo="+vself.oidgrupoatribuirop;
                }

                if (vself.oidsubgrupoatribuirop !== null){
                    filtroprodutos = filtroprodutos + " and p.idsubgrupo="+vself.oidsubgrupoatribuirop;
                }

                if (vself.oidsetoratribuirop !== null){
                    filtroprodutos = filtroprodutos + " and p.idsetor="+vself.oidsetoratribuirop;
                }                

                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : 'operacoestabelas'},
                    {parametro: 'tpoperacao', 		valor : vself.otpoperacao},
                    {parametro: 'idtabelaorigem',   valor : vself.oidtabelaorigem},
                    {parametro: 'idtabelaatribuir', valor : vself.oidtabelaatribuirop},
                    {parametro: 'filtroprodutos',   valor : filtroprodutos},
                    {parametro: 'margem',           valor : vself.omrgtabelaatribuirop},
                    {parametro: 'tpfatorajuste',    valor : vself.otpfatorajuste},                    
                    {parametro: 'fatorajuste',      valor : vself.ofatortabelaajuste},
                    {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',            valor : '002Z.002M.012M'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Procedimento realizado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = '';
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdexecutapesquisa();                       
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar a solicitação. Descrição do erro: '+response.message, 'Erro!');
                });                                
            },
            mtdnovalocalizacao(){
                if (!util.opcaousuario('001Z.009Y.001Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                
                    if (this.vidfiliallocalizacao == null) {
                        this.$toastr.w('Filial deve ser informada!', 'Atenção!');
                        $("#cbfilialestoque").select2('open');
                        return;
                    }
                    this.vnovalocalizacao        = true;
                    this.vdescricaolocalizacao   = '';
                    this.vidnovalocalizacao      = ''; 
                    setTimeout(() => {
                        $('#eddescricaolocalizacao').focus();                 
                    }, 200);   
                }              
            },
            mtdconfirmarnovalocalizacao(){                
                let vself  = this;

                if (vself.vidfiliallocalizacao == null) {
                    vself.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    $("#cbfilialestoque").select2('open');
                    return;
                }

                if (vself.vdescricaolocalizacao == '') {
                    vself.$toastr.w('Descrição da localização deve ser informada!', 'Atenção!');
                    $("#eddescricaolocalizacao").focus();
                    return;
                }

                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : '',
                    'descricao'         : vself.vdescricaolocalizacao.toUpperCase(),
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : 1},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '001Z.009Y.001Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlocalizacoes.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Localização cadastrada com sucesso!', 'Informação!');
                        vself.idnovalocalizacao     = response.data;
                        var defloc  = new Option(vself.vdescricaolocalizacao.toUpperCase(), vself.idnovalocalizacao, true, true);
                        $('#cblocalizacao').append(defloc).trigger('change'); 
                        setTimeout(() => {
                           vself.mtdinclocalizacao(); 
                        }, 200);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.idnovalocalizacao     = response.data.substring(4, 8);
                                var defloc  = new Option(vself.vdescricaolocalizacao.toUpperCase(), vself.idnovalocalizacao, true, true);
                                $('#cblocalizacao').append(defloc).trigger('change'); 
                                setTimeout(() => {
                                vself.mtdinclocalizacao(); 
                                }, 200);
                            break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                setTimeout(() => {
                                    $('#eddescricaolocalizacao').focus();                 
                                }, 200);                                 
                            break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdcancelarnovalocalizacao(){
                this.vnovalocalizacao        = false;
                this.vdescricaolocalizacao   = '';
                this.vidnovalocalizacao      = '';
                setTimeout(() => {
                    $("#cblocalizacao").select2('open');                             
                }, 200);                        
            },
            mtdexportarexcel(){
                $('#btexportarexcel').click();
            },        
            mtdarquivocodigos() {
                //limpa o arquivo do input file
                const file               = document.querySelector('#btselecionararquivo');
                file.value               = '';
                this.vnomearquivo        = '';
                ///////////////////////////////
                $('#btselecionararquivo').trigger('click');
            },            
            mtdrotinaprocessacodigos(){
                let vself = this;                
                
                let varquivo                = document.getElementById("btselecionararquivo").files[0];
                vself.vnomearquivo          = varquivo.name;

                let extarq = varquivo.name.substring(varquivo.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XLS'){
                    vself.$toastr.w("O arquivo selecionado não possui formato válido!", 'Atenção!');
                }else{ 
                    let loader      = vself.$loading.show();
                    let localsalvar = vself.$store.state.configpaths.pathconferencias + vself.$store.state.filialpadrao.idcliente;

                    let parametros      = [
                        {parametro: 'arquivo',          valor  : varquivo},
                        {parametro: 'localsalvar',      valor  : localsalvar},
                        {parametro: 'nomearquivo',      valor  : varquivo.name}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                    retorno.then(function (response) {
                        if ($.isNumeric(response.data.inf)){
                            $('#btselecionararquivo').val('');
                            vself.mtdprocessararquivocodigos(vself.$store.state.configpaths.pathconferencias + vself.$store.state.filialpadrao.idcliente+'/'+vself.vnomearquivo);
                        }else{
                            $('#btselecionararquivo').val('');
                            vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                        }
                        loader.hide();
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                        $('#btselecionararquivo').val('');
                    });
                }
            },
            mtdprocessararquivocodigos(arquivo){
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'processararquivocodigos'},
                    {parametro: 'arquivo',      valor : arquivo}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Arquivo processado com sucesso!', 'Informação!');
                    }else{
                        vself.$toastr.e(response.data, 'Erro!');
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdbaixarmatrizcodigos(){
                window.open(this.$store.state.configpaths.pathcontrole+'arquivosimportacao/manager/matrizes/matrizimportarcodigos.xls', '_blank');
            },
            mtddefinecodigoetqpadrao(codigo, atribuir, indice){
                for (let i = 0; i < this.lstCodigos.length; i++) {
                    if (this.lstCodigos[i].codigo === codigo){
                        this.lstCodigos[i].padraoetiqueta = atribuir;
                    }else{
                        this.lstCodigos[i].padraoetiqueta = 0;
                    }                    
                }
            },
            mtdcalculavalorimpostoclasse(){
                let vself   = this;
                let ret     = util.itemcomimposto(vself.iclasse, parseFloat(vself.ivalorbase), 1, 0, 0);

                vself.ivalorimposto    = ret.totalimpostoitem;
                vself.ivalorcomimposto = ret.vltotalitem;	                
            },
            mtdvisualizarimpostovalor(){
                if (parseInt(this.opcrud) < 3){
                    this.ivalorbase              = 0;
                    this.iidclasse               = null;
                    this.iclasse                 = [];
                    this.ivalorimposto           = 0;
                    this.ivalorcomimposto        = 0; 
                    $('#cbiclasse').val(null).trigger('change');            
                    $('#mdimpostovalor').modal('show');
                }
            },
            mtdselecionavalorbase(){
                this.vvltabela = this.ivalorbase;
                this.mtdcalculamrgtabela();
                this.iclasse   = [];    
                this.vvlvizu   = this.vvltabela;            
                $('#mdimpostovalor').modal('hide');                
            },
            mtddefinirmargemprvenda(){
                $('#mdatribuirmargem').modal('show');                
            },
            mtdcalculamargemprvendamedio(){
                let vlmrg   = parseFloat(this.vprcusto) * parseFloat(this.amargem) / 100;
                this.avalor = (parseFloat(this.vprcusto) + vlmrg).toFixed(2);
            },
            mtdaplicarvalorprvenda(){
                this.vprvendamedio = this.avalor;
                this.vmargemprcusto= this.amargem;
                $('#mdatribuirmargem').modal('hide');                
            },
            mtdinformarvalordescpromocional(){
                if (parseFloat(this.vvltabela) > 0){
                    $('#mdinformarvalordescpromocional').modal('show');                
                }
            },
            mtdcalcularvalordescpromocional(){
                let dif = parseFloat(this.avalorsemdescpromocional) - parseFloat(this.avalorcomdescpromocional);
                if (parseFloat(this.avalorsemdescpromocional) > 0){
                    this.amargemdescpromocional = (parseFloat(dif) / parseFloat(this.avalorsemdescpromocional) * 100).toFixed(2);                
                }else{
                    this.amargemdescpromocional = 0;
                }
            },
            mtdaplicarpercentualdescpromocional(){
                if (parseFloat(this.amargemdescpromocional) > 0){
                    this.vvldescpromocional = this.amargemdescpromocional;
                    $('#mdinformarvalordescpromocional').modal('hide');
                }else{
                    this.$toastr.w('Margem deve ser maior que 0(zero)!', 'Informação!');
                    $('#edvalorcomdescpromocional').focus(); 
                }
            },
			mtdimprimirpedido(idpedido, tp){				
				$('#mdmenupedido').modal('hide');
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirpedido.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idpedido='+idpedido+'&tpimp='+tp+'&idu='+
							this.$store.state.usuario.id, '_blank');				
			}           
        },
        mounted: function () {            
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('002Z.002M', vself.$store.state.perfilusuario)) {
                        vself.pathimgview           = vself.$store.state.configpaths.pathimagens;
                        $('#pnlista').fadeIn(700);
                        vself.mtdexecutapesquisa();
                        vself.mtdselect2_def();
                        setTimeout(function(){
                            util.transformartabssanfona(vself);
                        }, 120);
    
                        $("#mdajuste").on('shown.bs.modal', function(){
                            $(this).find('#edqtdmov').focus();
                        });                        

                        $(document).keydown(function (e) {
                            if(e.which === 27) {
                                $('#mdajuste').modal('hide');
                            }
                        });                         
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescricao === ''|| this.vidmarca == null || 
                this.vidgrupo == null || this.vidsubgrupo == null || 
                this.vidsetorproduto == null || this.vund == null || 
                this.vidncm == null; //|| this.lstTabelasPrecos.length == 0;
            },
            calculacusto:function () {
                //$('#cbtabelapreco').val(null).trigger('change');
                this.vmrgtabela         = 0;
                this.vvltabela          = 0;
                this.vcomissaotabela    = 0;
                this.vqtdmintabela      = 0;
                this.vdescontotabela    = 0;
                this.vvldescpromocional = 0;
                this.vprcusto = util.calculacustoproduto(this, this.vpipi/100,
                    this.vpicms/100,
                    this.vpfrete/100,
                    this.vvst,
                    this.vppis/100,
                    this.vpcofins/100,
                    this.vpoutros/100,
                    this.vprcompra,
                    this.vprvendamedio,
                    this.$store.state.filialpadrao.formulacustopro);
                this.mtdrecalcularmargemtabelas();
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregaprodutos(val);
            },
            vlimpardados(val){
                this.vimportarcodigos   = false;
                this.vreconstruirchaves = false;
            },
            oppreco(){
                this.vlink = '';
            },
            opvalor(){
                this.vlink = '';
            }
        }
    }
</script>
<style>
	#dv-btn-camera{
			display: none;
	}
	@media screen and (max-width: 767px) {
		#dv-btn-camera{
			display: block;
		}
    }
    .dp-impressao-pedido{
        position: absolute!important;
        top: 28px;
        right: 20px;                   
    }
    .icon-imprimir-pedido{
        cursor: pointer;
        font-size: 22px;
        color: #4250f2;     
    }
    .def-col-cod{
        width: 80px !important;
    }
    .def-col-opcoes-produto{
        width: 60px !important;
    }
    .img-produto{
        width: 180px !important;
        height: 180px !important;
    }
    .btn-del-imgproduto{
        position: absolute;
        top: 10px;
        left: 25px;
    }
    .def-col-slot-precos{
        width: 140px !important;
    }

	    .ver{
	        background-color: rgb(75, 165, 165) !important;
	    }
		.draco-prod-kpi{
			margin-top: 8px;
			padding: 10px 12px;
			border: 1px solid rgba(31, 94, 123, 0.2);
			border-radius: 10px;
			background: linear-gradient(120deg, #f7fbfd 0%, #edf5f9 100%);
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
		.draco-prod-kpi-label{
			color: #375264;
			font-weight: 700;
			font-size: 12px;
			letter-spacing: .01em;
		}
		.draco-prod-kpi-value{
			color: #1f5e7b;
			font-weight: 800;
			font-size: 20px;
		}
	</style>
